import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box, Grid, TextField, Button, Typography, Checkbox, FormControlLabel, Stack, Tooltip, Paper, Chip } from '@mui/material';
import Scrollbar from "./Scrollbar";
import moment from "moment";
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import { BedtimeOutlined, DeleteOutline, NightsStayOutlined } from "@mui/icons-material";
import Select from 'react-select'
import AsyncSelect from "react-select/async";
import { API } from "../../api/api";
import { END_POINTS } from "../../api/endpoints";
import * as templateAction from '../../redux/actions/templateActions';
import * as prescriptionAction from '../../redux/actions/prescriptionActions';
import { store } from '../../redux/store/index';
import { useSelector } from "react-redux";
import * as consultationAction from '../../redux/actions/consultationScheduleActions';
import * as treatmentAction from '../../redux/actions/consultationActions';
import { ConsultationContext, } from "../../context/ConsultationContext";
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import { formatWeeks } from "../../utils/formatWeekAndDays";
import { styled } from '@mui/material/styles';
import { socket } from "../../socket/socket";
import AsyncCreatableSelect from "react-select/async-creatable";
import { useToast } from "../../context/ToastContext";
import usePermissions from "../../utils/permissions";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CommonGate from "./Gate";
import PreconceptionLeapPanel from "./PreconceptionLeapPanel";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Skeleton } from "@mui/material";
import FollowUpWeekPicker from "./FollowUpDate";
import { ReactComponent as Male } from '../../assets/male.svg';
import { ReactComponent as Female } from '../../assets/woman.svg';

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 32,
    height: 16,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 1,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: 'rgba(242, 119, 4, 1)',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 14,
        height: 14,
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        backgroundColor: 'rgba(166, 166, 166, 1)',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

const styles = {
    fixedBox: {
        position: 'absolute',
        right: 18,
        width: 5,
        bgcolor: '#FFCA67',
        transition: 'background-color 0.3s ease',
    },
    select: {
        container: (base) => ({
            ...base,
            // flex: 1,
            width: '34px',
        }),
        control: (base) => ({
            ...base,
            border: 'none',
            padding: '0',
            boxShadow: 'none',
            //   height: '10px',
            minHeight: '36px',
            borderRadius: 0,
            backgroundColor: 'transparent'
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '14px',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            display: 'none',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0',
            marginTop: '0',
            backgroundColor: '#FFF',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? "grey"
                : state.isFocused
                    ? "#D3D3D3"
                    : "transparent",
            color: state.isSelected ? "#fff" : "black",
            cursor: "pointer",
        }),
    },
    asyncSelect: {
        container: (base) => ({
            ...base,
            // flex: 1,
            width: '155px',
        }),
        control: (base) => ({
            ...base,
            border: '1px solid #E6E8EC',
            padding: '0',
            // boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
            borderRadius: '5px',
            height: '29px',
        }),
        valueContainer: (base) => ({
            ...base,
            height: '100%',
            padding: '0 8px',
            fontSize: '14px',
        }),
        indicatorSeparator: () => ({
            display: 'none',
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontSize: '14px',
        }),

        singleValue: (base) => ({
            ...base,
            lineHeight: '29px',
            fontSize: '14px',
        }),
        dropdownIndicator: (base) => ({
            ...base,
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0',
            marginTop: '0',
            backgroundColor: '#FFF',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? "grey"
                : state.isFocused
                    ? "#D3D3D3"
                    : "transparent",
            color: state.isSelected ? "#fff" : "black",
            cursor: "pointer",
        }),
    }

};
const buildStyles = {
    dropdownIndicator: (base) => ({
        ...base,
        display: 'none',
        backgroundColor: 'transparent'
    }),
    control: (base) => ({
        ...base,
        border: '1px solid #E6E8EC',
        padding: '0',
        // boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
        borderRadius: '5px',
        height: '29px',
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '11px',
        backgroundColor: state.isSelected
            ? "grey"
            : state.isFocused
                ? "#D3D3D3"
                : "transparent",
        color: state.isSelected ? "#fff" : "black",
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    singleValue: (styles) => ({
        ...styles,
        fontSize: '11px',
    }),
    container: (base) => ({
        ...base,
        // flex: 1,
        width: '104px',
    }),
};

const DEFAULT_CONSUMER_PROTOCOLS = [
    {
        module: 'GLUCOSE_SMBG',
        label: 'Blood Glucose (SMBG)',
        frequency: '4x Daily (Fasting, Post-Breakfast, Post-Lunch, Post-Dinner)',
        description: 'Fasting and 2hr post-meal glucose logs & trend tracking',
    },
    {
        module: 'BLOOD_PRESSURE',
        label: 'Home Blood Pressure',
        frequency: '2x Daily (Morning & Evening)',
        description: 'Morning & evening blood pressure monitoring with alert triggers',
    },
    {
        module: 'PREECLAMPSIA_CHECK',
        label: 'Pre-Eclampsia Symptom Check',
        frequency: 'Daily (19:00)',
        description: 'Daily 5-second screener for headache, vision blur, epigastric pain',
    },
    {
        module: 'THYROXINE_GUARD',
        label: 'Thyroxine Guard Protocol',
        frequency: 'Daily Morning (06:30)',
        description: 'Empty stomach thyroxine reminder & 4-hour mineral gap guard',
    },
    {
        module: 'IRON_ADHERENCE',
        label: 'Iron Adherence Booster',
        frequency: 'Daily Afternoon (14:00)',
        description: 'Afternoon reminder with Vitamin C absorption pairing',
    },
    {
        module: 'DFMR_KICK_COUNTER',
        label: 'Fetal Movement Record (DFMR)',
        frequency: 'Daily Evening (20:00)',
        description: 'Daily fetal kick session (10 movements in 2 hours, 28w+)',
    },
];

const Treatment = () => {
    const { patientId, consultationId } = useParams();
    const currentObservationRef = useRef(null);
    const selectedWeekRef = useRef(null);
    const [showPastWeeks, setPastWeeks] = useState(false);
    const [selectedDate, setSelectedDate] = useState(
        moment().format('MM/DD/YYYY'),
    );
    const [supplementPrescription, setSupplementPrescription] = useState([])
    const [symptomBasedPrescription, setSymptomBasedPrescription] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const templateReducer = useSelector((state) => state.templateReducer);
    const prescriptionReducer = useSelector((state) => state.prescriptionReducer);
    const [templates, saveTemplates] = useState([])
    const consultationReducer = useSelector((state) => state.consultationReducer);
    const [currentTreatment, setCurrentTreatment] = useState([])
    const [edit, setEdit] = useState(true)
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState(null);
    const [getTreatmentDetails, setTreatmentDetails] = useState(consultationReducer?.treatmentDetails)
    const [checked, setChecked] = useState(true);
    const [supplementchecked, setSupplementChecked] = useState(true);
    const [symptomChecked, setSymptomChecked] = useState(true);
    const [followUpChecked, setFollowUpChecked] = useState(true);
    const [updateTreatment, setUpdateTreatment] = useState({
        // followUpTests: [],
        // nextAntenatalTests: [],
        // followUpTestRemarks: '',
        // observations: '',
        // followUpTestDate: null
    })
    const patientReducer = useSelector((state) => state.patientReducer);
    const { setChildData } = useContext(ConsultationContext);
    const [loader, setLoader] = useState(true)
    const [initialSupplement, setInitialSupplement] = useState([]);
    const [initialSymptom, setInitialSymptom] = useState([]);
    const patientType = patientReducer?.patientInfo?.patientType || 'OBSTETRIC';
    const patientConditions = patientReducer?.patientInfo?.conditions || [];
    const isPreconception = patientConditions.some(c => c?.code === "PRECONCEPTION" || c?.name?.toUpperCase().includes("PRECONCEPTION"));
    const [selectedAdditionalTest, setSelectedAdditionalTest] = useState(null);
    const inputRef = useRef(null);
    const showToast = useToast()
    const { hasPermission } = usePermissions();
    const prescriptionCreationPower = hasPermission('PRESCRIPTION_CREATE')
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [recommendation, setRecommendation] = useState(null);
    const [selectedTests, setSelectedTests] = useState([]);
    const [selectedConsumerModules, setSelectedConsumerModules] = useState([]);
    const [consumerProtocols, setConsumerProtocols] = useState([]);
    const [loading, setLoading] = useState(false);
    const [generating, setGenerating] = useState(false);
    const pollingTimeout = useRef(null);
    const loadingMessages = [
        "Reviewing patient history…",
        "Checking examination…",
        "Matching against screening guidelines…",
        "Ranking recommendations by confidence…",
    ];
    const [messageIndex, setMessageIndex] = useState(0);
    const [recommendationError, setRecommendationError] = useState(false);
    const [manualRecommendation, setManualRecommendation] = useState({
        startDate: null,
        endDate: null
    });

    const availableConsumerProtocols = (consumerProtocols && consumerProtocols.length > 0)
        ? consumerProtocols
        : DEFAULT_CONSUMER_PROTOCOLS.map(dp => {
            const isRec =
                (dp.module === 'GLUCOSE_SMBG' && patientConditions.some(c => c?.code?.includes('GDM') || c?.name?.toUpperCase().includes('DIABETES'))) ||
                (dp.module === 'BLOOD_PRESSURE' && patientConditions.some(c => c?.code?.includes('PE') || c?.code?.includes('HYPERTENSION') || c?.name?.toUpperCase().includes('HYPERTENSION'))) ||
                (dp.module === 'PREECLAMPSIA_CHECK' && patientConditions.some(c => c?.code?.includes('PE') || c?.name?.toUpperCase().includes('PREECLAMPSIA'))) ||
                (dp.module === 'THYROXINE_GUARD' && patientConditions.some(c => c?.code?.includes('THYROID') || c?.name?.toUpperCase().includes('THYROID'))) ||
                (dp.module === 'IRON_ADHERENCE' && patientConditions.some(c => c?.code?.includes('ANEMIA') || c?.name?.toUpperCase().includes('ANEMIA'))) ||
                (dp.module === 'DFMR_KICK_COUNTER' && (patientReducer?.patientInfo?.currentWeek || 0) >= 28);
            return {
                ...dp,
                isRecommended: isRec,
                isActive: false,
            };
        });
    const [confirmedRecommendationSnapshot, setConfirmedRecommendationSnapshot] = useState(null);

    useEffect(() => {
        if (!generating) return;

        const interval = setInterval(() => {
            setMessageIndex((prev) => (prev + 1) % loadingMessages.length);
        }, 1800);

        return () => clearInterval(interval);
    }, [generating]);

    useEffect(() => {
        fetchRecommendation();
        return () => {
            if (pollingTimeout.current) {
                clearTimeout(pollingTimeout.current);
            }
        };
    }, [consultationId]);

    const fetchRecommendation = async () => {
        try {
            setLoading(true);
            const response = await API.get(
                `/v1/consultations/${consultationId}/recommendation`
            );
            if (!response.success) {
                setRecommendationError(true);
                return;
            }
            const recommendation = response.data;
            if (!recommendation) {
                await generateRecommendation();
                return;
            }
            setRecommendation(recommendation);
            if (recommendation?.consumerProtocols && recommendation.consumerProtocols.length > 0) {
                setConsumerProtocols(recommendation.consumerProtocols);
                if (recommendation.isConfirmed) {
                    const activeModules = recommendation.consumerProtocols
                        .filter(p => p.isActive)
                        .map(p => p.module);
                    setSelectedConsumerModules(activeModules);
                } else {
                    const recommendedModules = recommendation.consumerProtocols
                        .filter(p => p.isRecommended)
                        .map(p => p.module);
                    setSelectedConsumerModules(recommendedModules);
                }
            } else {
                const defaultSelected = DEFAULT_CONSUMER_PROTOCOLS
                    .filter(dp => {
                        return (dp.module === 'GLUCOSE_SMBG' && patientConditions.some(c => c?.code?.includes('GDM') || c?.name?.toUpperCase().includes('DIABETES'))) ||
                            (dp.module === 'BLOOD_PRESSURE' && patientConditions.some(c => c?.code?.includes('PE') || c?.code?.includes('HYPERTENSION') || c?.name?.toUpperCase().includes('HYPERTENSION'))) ||
                            (dp.module === 'PREECLAMPSIA_CHECK' && patientConditions.some(c => c?.code?.includes('PE') || c?.name?.toUpperCase().includes('PREECLAMPSIA'))) ||
                            (dp.module === 'THYROXINE_GUARD' && patientConditions.some(c => c?.code?.includes('THYROID') || c?.name?.toUpperCase().includes('THYROID'))) ||
                            (dp.module === 'IRON_ADHERENCE' && patientConditions.some(c => c?.code?.includes('ANEMIA') || c?.name?.toUpperCase().includes('ANEMIA'))) ||
                            (dp.module === 'DFMR_KICK_COUNTER' && (patientReducer?.patientInfo?.currentWeek || 0) >= 28);
                    })
                    .map(dp => dp.module);
                setSelectedConsumerModules(defaultSelected);
            }

            if (recommendation.isConfirmed) {
                const confirmedModules = recommendation?.consumerProtocols
                    ? recommendation.consumerProtocols.filter(p => p.isActive).map(p => p.module).sort()
                    : [];
                setConfirmedRecommendationSnapshot({
                    selectedTests:
                        recommendation?.tests
                            ?.filter(test => test.status === "ACCEPTED")
                            ?.map(test => test.tenantTestId)
                            ?.sort() || [],

                    selectedConsumerModules: confirmedModules,

                    startDate: recommendation?.nextVisit?.fromDate
                        ? moment(recommendation.nextVisit.fromDate).format("YYYY-MM-DD")
                        : null,

                    endDate: recommendation?.nextVisit?.toDate
                        ? moment(recommendation.nextVisit.toDate).format("YYYY-MM-DD")
                        : null
                });
            }
            const acceptedTestId = recommendation?.tests
                ?.filter(test => test.status === "ACCEPTED")
                ?.map(test => test.tenantTestId) || [];
            setSelectedTests(acceptedTestId || []);
            if (recommendation?.nextVisit?.fromDate) {
                setManualRecommendation({
                    startDate: moment(recommendation.nextVisit.fromDate).format("YYYY-MM-DD"),
                    endDate: recommendation.nextVisit.toDate ? moment(recommendation.nextVisit.toDate).format("YYYY-MM-DD") : ""
                });
            }
            if (
                recommendation.status === "GENERATING" ||
                !recommendation.isReady
            ) {
                pollRecommendation();
            }
        } catch (e) {
            setRecommendationError(true);
        } finally {
            setLoading(false);
        }
    };

    const generateRecommendation = async () => {
        try {
            setRecommendationError(false);
            setGenerating(true);

            const response = await API.post(
                `/v1/consultations/${consultationId}/recommendation`
            );

            if (!response.success) {
                setRecommendationError(true);
                setGenerating(false);
                showToast("Failed to generate recommendation", "error");
                return;
            }

            showToast("Generating recommendation...", "info");
            pollRecommendation();

        } catch (e) {
            setRecommendationError(true);
            setGenerating(false);
            showToast("Error generating recommendation", "error");
        }
    };
    const pollRecommendation = async () => {

        try {
            const response = await API.get(
                `/v1/consultations/${consultationId}/recommendation`
            );
            if (!response.success) return;
            const recommendation = response.data;
            setRecommendation(recommendation);
            if (recommendation.isReady) {
                setGenerating(false);

                if (recommendation?.consumerProtocols && recommendation.consumerProtocols.length > 0) {
                    setConsumerProtocols(recommendation.consumerProtocols);
                    if (recommendation.isConfirmed) {
                        const activeModules = recommendation.consumerProtocols
                            .filter(p => p.isActive)
                            .map(p => p.module);
                        setSelectedConsumerModules(activeModules);
                    } else {
                        const recommendedModules = recommendation.consumerProtocols
                            .filter(p => p.isRecommended)
                            .map(p => p.module);
                        setSelectedConsumerModules(recommendedModules);
                    }
                }

                const acceptedTestId = recommendation?.tests
                    ?.filter(test => test.status === "ACCEPTED" || !recommendation.isConfirmed)
                    ?.map(test => test.tenantTestId)
                    ?.filter(Boolean) || [];
                setSelectedTests(acceptedTestId || []);
                if (recommendation?.nextVisit?.fromDate) {
                    setManualRecommendation({
                        startDate: moment(recommendation.nextVisit.fromDate).format("YYYY-MM-DD"),
                        endDate: recommendation.nextVisit.toDate ? moment(recommendation.nextVisit.toDate).format("YYYY-MM-DD") : ""
                    });
                }
                showToast("Recommendation updated", "success");
                return;
            }
            pollingTimeout.current = setTimeout(() => {
                pollRecommendation();
            }, 2000);

        } catch (error) {
            pollingTimeout.current = setTimeout(() => {
                pollRecommendation();
            }, 2000);
        }
    };

    const handleTestSelection = (testId) => {
        setSelectedTests(previous => {
            if (previous.includes(testId)) {
                return previous.filter(id => id !== testId);
            }
            return [...previous, testId];
        });
    };

    const handleConsumerModuleToggle = (moduleKey) => {
        setSelectedConsumerModules(previous => {
            if (previous.includes(moduleKey)) {
                return previous.filter(id => id !== moduleKey);
            }
            return [...previous, moduleKey];
        });
    };

    const confirmRecommendation = async () => {
        const payload = {
            recommendationId: recommendation?.id ?? null,
            acceptedTestIds: selectedTests,
            consumerModules: selectedConsumerModules,
            startDate: manualRecommendation.startDate
                ? moment(manualRecommendation.startDate).format("YYYY-MM-DD")
                : null,
            endDate: manualRecommendation.endDate
                ? moment(manualRecommendation.endDate).format("YYYY-MM-DD")
                : null
        };
        const response = await API.post(
            `/v1/consultations/${consultationId}/recommendation/confirm`,
            payload
        );
        if (response.success) {
            showToast("Recommendation confirmed", "success");
            fetchRecommendation();
        }
    };

    const hasRecommendationChanges = () => {
        if (!recommendation?.isConfirmed) {
            return true;
        }

        if (!confirmedRecommendationSnapshot) {
            return false;
        }

        const currentTests = [...selectedTests].sort();

        const testsChanged =
            JSON.stringify(currentTests) !==
            JSON.stringify(confirmedRecommendationSnapshot.selectedTests);

        const currentStartDate = manualRecommendation.startDate
            ? moment(manualRecommendation.startDate).format("YYYY-MM-DD")
            : recommendation?.nextVisit?.fromDate
                ? moment(recommendation.nextVisit.fromDate).format("YYYY-MM-DD")
                : null;

        const currentEndDate = manualRecommendation.endDate
            ? moment(manualRecommendation.endDate).format("YYYY-MM-DD")
            : recommendation?.nextVisit?.toDate
                ? moment(recommendation.nextVisit.toDate).format("YYYY-MM-DD")
                : null;

        const datesChanged =
            currentStartDate !== confirmedRecommendationSnapshot.startDate ||
            currentEndDate !== confirmedRecommendationSnapshot.endDate;

        const currentModules = [...selectedConsumerModules].sort();
        const modulesChanged =
            JSON.stringify(currentModules) !==
            JSON.stringify(confirmedRecommendationSnapshot.selectedConsumerModules || []);

        return testsChanged || datesChanged || modulesChanged;
    };

    useEffect(() => {
        setTreatmentDetails({});
        setUpdateTreatment({
            followUpTests: [],
            nextAntenatalTests: [],
            followUpTestRemarks: '',
            observations: '',
            followUpTestDate: null
        });
        setSupplementPrescription([]);
        setSymptomBasedPrescription([]);
        setCurrentTreatment([]);
        setLoader(true);
    }, [consultationId]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const mode = queryParams.get('mode');
        if (mode) {
            setEdit(mode == "view" ? false : hasPermission("TREATMENT_CREATE") ? true : false);
        }
    }, [location.search]);

    useEffect(() => {
        store.dispatch(treatmentAction.getTreatmentRequestAction(consultationId))
    }, [])


    useEffect(() => {
        if (consultationReducer?.treatmentDetails?.id && !consultationReducer.requestState) {
            const timeout = setTimeout(() => {
                setTreatmentDetails(consultationReducer.treatmentDetails);
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, [consultationReducer?.treatmentDetails]);


    useEffect(() => {
        if (patientId) {
            store.dispatch(prescriptionAction.getPatientPrescriptionRequestAction(consultationId))
            if (isPreconception) {
                store.dispatch(prescriptionAction.getRecommendedPrescriptionRequestAction(consultationId, "SUPPLEMENT"))
            }
            if (patientType !== "GYNECOLOGY") {
                store.dispatch(prescriptionAction.getRecommendedPrescriptionRequestAction(consultationId, "SUPPLEMENT"))
                store.dispatch(templateAction.getAllTemplateRequestAction());
                store.dispatch(consultationAction.getPatientNextConsultationTestRequestAction(patientId));
                store.dispatch(consultationAction.getRecommendedAdditionalTestRequestAction(consultationId));
            }
            store.dispatch(consultationAction.getFollowUpTestRequestAction(consultationId));
            store.dispatch(consultationAction.getConsultationObservationRequestAction(patientId));
        }
    }, [patientId])

    useEffect(() => {
        if (templateReducer?.templates) {
            saveTemplates(templateReducer.templates);
        }
    }, [templateReducer]);

    useEffect(() => {
        if (!patientId) return;
        const handleCommandOutput = (data) => {
            console.log("data came on event", data)
            const [, , rawCardType] = data?.data?.originActionType?.split('.');

            let cardType = rawCardType;
            let cardKey = rawCardType;
            if (rawCardType.includes(':')) {
                const [cardCategory, id] = rawCardType.split(':');
                cardType = cardCategory
                cardKey = rawCardType
            }
            if (consultationId !== data?.data?.consultationId) {
                return
            }
            if (
                data?.actionType === "commandOutput.refreshWebDashboard"
            ) {
                if (cardType == "followUp" || cardType == "observation" || cardType == "nextAntenatalTests") {
                    store.dispatch(treatmentAction.getTreatmentRequestAction(consultationId))
                }
            }
            if (cardType == "supplementPrescription" || cardType == "symptomPrescription") {
                store.dispatch(prescriptionAction.getPatientPrescriptionRequestAction(consultationId))
            }

            if (cardType == "pathways") {
                fetchRecommendation()
            }
        };
        socket.on("commandOutput", handleCommandOutput);
    }, [patientId]);

    const forceSupplementRefresh = useRef(false);

    useEffect(() => {
        const handleForceRefresh = () => { forceSupplementRefresh.current = true; };
        window.addEventListener('force_supplement_refresh', handleForceRefresh);
        return () => window.removeEventListener('force_supplement_refresh', handleForceRefresh);
    }, []);

    useEffect(() => {
        if (!prescriptionReducer) return;

        const savedPrescription = prescriptionReducer.savedPrescription || [];

        const supplement = savedPrescription.find(p => p.type === 'SUPPLEMENT');
        const symptomBased = savedPrescription.find(p => p.type === 'SYMPTOM_BASED');

        const hasSavedDataLoaded = Array.isArray(savedPrescription) && savedPrescription.length > 0;
        const hasValidSaved = supplement || symptomBased;

        if (edit) {
            let useSaved = hasSavedDataLoaded && hasValidSaved;
            
            if (forceSupplementRefresh.current) {
                if (prescriptionReducer.requestState === false && prescriptionReducer.status === 'Recommended Prescription retrieved sucessfully') {
                    if (prescriptionReducer.prescriptionType !== 'SYMPTOM_BASED') {
                        setSupplementPrescription(prescriptionReducer.prescription || []);
                    }
                    forceSupplementRefresh.current = false;
                    useSaved = false; 
                } else {
                    useSaved = false; 
                }
            }

            if (useSaved) {
                const supplementData = supplement?.medicines || [];
                const symptomData = symptomBased?.medicines || [];
                setSupplementPrescription(supplementData);
                setSymptomBasedPrescription(symptomData);
                setInitialSupplement(JSON.stringify(supplementData));
                setInitialSymptom(JSON.stringify(symptomData));
            } else if (!hasSavedDataLoaded && !forceSupplementRefresh.current) {
                setSupplementPrescription(prescriptionReducer.prescription || []);
                setSymptomBasedPrescription(prescriptionReducer.symptomBased || []);
            }
        } else {
            setSupplementPrescription(supplement?.medicines || []);
            setSymptomBasedPrescription(symptomBased?.medicines || []);
        }

    }, [prescriptionReducer, edit]);


    useEffect(() => {
        if (consultationReducer?.treatments) {
            setCurrentTreatment(consultationReducer?.treatments)
        }
    }, [consultationReducer]);

    useEffect(() => {
        if (!getTreatmentDetails || Object.keys(getTreatmentDetails).length === 0) {
            setUpdateTreatment({
                followUpTests: [],
                nextAntenatalTests: [],
                followUpTestRemarks: '',
                observations: '',
                followUpTestDate: null
            });
            return;
        }

        if (getTreatmentDetails?.followUpTests?.length) {
            setUpdateTreatment(prev => ({
                ...prev,
                followUpTests: getTreatmentDetails.followUpTests.map(test => ({
                    testId: test.id
                }))
            }));
        }
        if (getTreatmentDetails?.followUpTestRemarks) {
            setUpdateTreatment(prev => ({
                ...prev,
                followUpTestRemarks: getTreatmentDetails.followUpTestRemarks
            }));
        }

        if (getTreatmentDetails?.observations) {
            setUpdateTreatment(prev => ({
                ...prev,
                observations: getTreatmentDetails.observations
            }));
        }

        if (getTreatmentDetails?.followUpTestDate) {
            setUpdateTreatment(prev => ({
                ...prev,
                followUpTestDate: getTreatmentDetails?.followUpTestDate
            }));
        }

    }, [getTreatmentDetails, consultationReducer?.nextConsultationInfo?.antenatalTests]);

    useEffect(() => {
        const antenatalTestsFromTreatment = getTreatmentDetails?.nextAntenatalTests;
        const fallbackAntenatalTests = consultationReducer?.nextConsultationInfo?.antenatalTests;

        if (Array.isArray(antenatalTestsFromTreatment) && antenatalTestsFromTreatment.length > 0) {
            setUpdateTreatment(prev => ({
                ...prev,
                nextAntenatalTests: antenatalTestsFromTreatment.map(test => ({
                    testId: test.id,
                    testName: test.testName,
                    isAdditional: test.isAdditional
                }))
            }));
        } else if (Array.isArray(fallbackAntenatalTests) && fallbackAntenatalTests.length > 0) {
            setUpdateTreatment(prev => ({
                ...prev,
                nextAntenatalTests: fallbackAntenatalTests.map(test => ({
                    testId: test.testId,
                    testName: test.testName,
                    isAdditional: false
                }))
            }));
        } else {
            setUpdateTreatment(prev => ({
                ...prev,
                nextAntenatalTests: []
            }));
        }
    }, [getTreatmentDetails?.nextAntenatalTests, consultationReducer?.nextConsultationInfo?.antenatalTests]);

    useEffect(() => {
        if (patientId) {
            store.dispatch(prescriptionAction.getRecommendedPrescriptionRequestAction(consultationId, "SYMPTOM_BASED"))
        }
    }, [patientId])

    useEffect(() => {
        const payload = {
            ...updateTreatment,
            nextAntenatalTests:
                updateTreatment?.nextAntenatalTests?.map(
                    ({ testName, ...rest }) => rest
                )
        };
        setChildData(payload)
    }, [updateTreatment]);

    useEffect(() => {
        if (consultationId) {
            const timeout = setTimeout(() => {
                setLoader(false);
            }, 500);

            return () => clearTimeout(timeout);
        }
    }, [consultationId]);

    const handleChangeDosage = (type, index, doseType) => {
        if (type !== "symptom") {
            if (!selectedTemplate) {
                // Toggle the value between 0 and 1
                setSupplementPrescription(prevState => {
                    const updatedPrescriptions = [...prevState];
                    updatedPrescriptions[index] = {
                        ...updatedPrescriptions[index],
                        [doseType]: updatedPrescriptions[index][doseType] === 1 ? 0 : 1
                    };
                    return updatedPrescriptions;
                });
            }
            else {
                saveTemplates(prevData =>
                    prevData?.map(template => {
                        if (template.name == selectedTemplate.name) {
                            const updatedPrescriptions = [...template.medicines];
                            updatedPrescriptions[index] = {
                                ...updatedPrescriptions[index],
                                [doseType]: updatedPrescriptions[index][doseType] === 1 ? 0 : 1
                            };
                            setSelectedTemplate({ ...selectedTemplate, medicines: updatedPrescriptions })
                            return {
                                ...template,
                                medicines: updatedPrescriptions
                            };
                        }
                        return template;
                    })
                );
            }
        }
        else {
            setSymptomBasedPrescription(prevState => {
                const updatedPrescriptions = [...prevState];
                updatedPrescriptions[index] = {
                    ...updatedPrescriptions[index],
                    [doseType]: updatedPrescriptions[index][doseType] === 1 ? 0 : 1
                };
                return updatedPrescriptions;
            });
        }
    };

    const handleCurrentTestsClick = () => {
        setPastWeeks(false)
        if (currentObservationRef.current) {
            currentObservationRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    };

    const handleChange = (type, value, fieldName, index) => {
        if (type !== "symptom") {
            if (selectedTemplate == null) {
                setSupplementPrescription(prevState => {
                    const updatedPrescriptions = [...prevState];
                    updatedPrescriptions[index] = {
                        ...updatedPrescriptions[index],
                        [fieldName]: typeof (value) == "object" ? value[fieldName]
                            : value
                    };
                    if (typeof (value) === "object") {
                        updatedPrescriptions[index] = {
                            ...updatedPrescriptions[index],
                            medicineId: value.medicineId,
                            indication: value.indication
                        };
                    }
                    return updatedPrescriptions;
                });
            }
            else {
                saveTemplates(prevData =>
                    prevData?.map(template => {
                        if (template.name == selectedTemplate.name) {

                            const updatedPrescriptions = [...template.medicines];
                            updatedPrescriptions[index] = {
                                ...updatedPrescriptions[index],
                                [fieldName]: typeof (value) == "object" ? value[fieldName]
                                    : value
                            };
                            if (typeof (value) === "object") {
                                updatedPrescriptions[index] = {
                                    ...updatedPrescriptions[index],
                                    medicineId: value.medicineId,
                                    indication: value.indication
                                };
                            }
                            setSelectedTemplate({ ...selectedTemplate, medicines: updatedPrescriptions })
                            return {
                                ...template,
                                medicines: updatedPrescriptions
                            };
                        }
                        return template;
                    })
                );
            }
        }
        else {
            setSymptomBasedPrescription(prevState => {
                const updatedPrescriptions = [...prevState];
                updatedPrescriptions[index] = {
                    ...updatedPrescriptions[index],
                    [fieldName]: typeof (value) == "object" ? value[fieldName]
                        : value
                };
                if (typeof (value) === "object") {
                    updatedPrescriptions[index] = {
                        ...updatedPrescriptions[index],
                        medicineId: value.medicineId,
                        indication: value.indication
                    };
                }
                return updatedPrescriptions;
            });
        }
    };

    const deleteMedicine = (indexToRemove, type) => {
        if (type !== "symptom") {
            if (!selectedTemplate) {
                const updatedPrescription = [...supplementPrescription];
                updatedPrescription.splice(indexToRemove, 1);
                setSupplementPrescription(updatedPrescription);
            }
            else {
                saveTemplates(prevData =>
                    prevData?.map(template => {
                        if (template.name == selectedTemplate.name) {

                            const updatedPrescriptions = [...template.medicines];
                            updatedPrescriptions.splice(indexToRemove, 1);
                            setSelectedTemplate({ ...selectedTemplate, medicines: updatedPrescriptions })
                            return {
                                ...template,
                                medicines: updatedPrescriptions
                            };
                        }
                        return template;
                    })
                );
            }
        }
        else {
            const updatedPrescription = [...symptomBasedPrescription];
            updatedPrescription.splice(indexToRemove, 1);
            setSymptomBasedPrescription(updatedPrescription);
        }

    }

    const loadOptions = async (inputValue, type) => {
        try {

            if (inputValue.length < 2) {
                return []
            }

            // todo api hit 
            const medicineResponse = await API.get(`${END_POINTS.medicineList(inputValue, type)}`);
            if (!medicineResponse.success) throw new Error(medicineResponse.message);
            const medicneList = medicineResponse.data

            const filteredData = medicneList.filter(item =>
                item.drugName.toLowerCase().includes(inputValue.toLowerCase())
            );

            if (filteredData.length === 0) {
                return [];
            }

            return filteredData?.map(item => ({
                ...item,
                label: item.drugName,
                value: item.drugName
            }));

        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };

    const renderInstruction = (fieldName, fieldValue, index, type) => {
        const options = [{ name: 'After Meals', value: 'AFTER_MEAL' }, { name: 'Before Meals', value: 'BEFORE_MEAL' }]
        const findSelectedOption = fieldValue !== undefined && fieldValue !== null ? options.find(item => {
            if (item.name === fieldValue || item.value === fieldValue) {
                return item
            }
        }) : ""

        return (
            <Select
                onChange={(event) => {
                    if (fieldName === 'instruction') {
                        handleChange(type, event.value, "instruction", index)
                    }
                }}
                value={findSelectedOption ? { name: findSelectedOption.name, value: findSelectedOption.value } : ''}
                getOptionLabel={option => {
                    return option.name || ''
                }}
                getOptionValue={option => {
                    return option.value || ''
                }}
                options={options}
                isSearchable={false}
                styles={{
                    ...buildStyles, menuPortal: (base) => ({ ...base, zIndex: 9999 }), container: (base) => ({
                        ...base,
                        width: isMobile ? '130px' : '104px',
                    }),
                }}
                isDisabled={!edit || !checked ||
                    (type === undefined && !supplementchecked)
                    || (type !== undefined && !symptomChecked) || !prescriptionCreationPower
                }
                menuPortalTarget={document.body}
            // isDisabled={!edit || !checked || !supplementchecked ||!symptomChecked}
            />
        );
    };

    const renderDuration = (fieldName, fieldValue, index, type) => {
        const options = [{ name: "D" }, { name: "W" }, { name: "M" }]
        const findSelectedOption = fieldValue !== undefined && fieldValue !== null ? options.find(item => {
            if (item.name === fieldValue) {
                return item
            }
        }) : ""

        return (
            <Select
                onChange={(event) => {
                    if (fieldName === 'durationUnit') {
                        handleChange(type, event.name, "durationUnit", index)
                    }
                }}
                value={{ name: fieldValue !== undefined && fieldValue !== null ? findSelectedOption?.name : '' }}
                getOptionLabel={option => {
                    return option.name
                }}
                getOptionValue={option => {
                    return option.name
                }}
                options={options}
                isSearchable={false}
                styles={{ ...styles.select, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                menuPortalTarget={document.body}
                isDisabled={!edit || !checked ||
                    (type === undefined && !supplementchecked)
                    || (type !== undefined && !symptomChecked) || !prescriptionCreationPower
                }
            // isDisabled={!edit || !checked || !supplementchecked ||!symptomChecked}
            />
        );
    };

    const handleToggleMedicines = (medicines) => {
        setSupplementPrescription(medicines)
    }

    const handleCreateTemplate = () => {
        const newTemplate = {
            name: `TM ${templates.length + 1}`,
            medicines: supplementPrescription
        };

        saveTemplates((prevState) => {
            return [...prevState, newTemplate];
        });

        const requestBody = {
            name: `TM ${templates.length + 1}`,
            medicines: supplementPrescription?.map(({ drugName, ...rest }) => rest)
        };

        store.dispatch(templateAction.createTemplateRequestAction(requestBody));

    }

    const updateTemplate = (templateToBeUpdated) => {
        saveTemplates(prevData =>
            prevData.map(template => {
                if (template.name == templateToBeUpdated.name) {
                    return {
                        ...template,
                        medicines: templateToBeUpdated.medicines
                    };
                }
                return template;
            })
        );
        const updateRequestBody = {
            name: templateToBeUpdated.name,
            medicines: templateToBeUpdated.medicines.map(({ drugName, label, value, ...rest }) => rest)
        };
        store.dispatch(templateAction.createTemplateRequestAction(updateRequestBody));
        // todo api for updating the template
    }

    const handleAddMedicine = (data, type) => {
        if (type !== "symptom") {
            if (!selectedTemplate) {
                setSupplementPrescription(prevState => {
                    const updatedPrescriptions = [...prevState];
                    const { value, label, ...rest } = data;
                    updatedPrescriptions.push(rest)
                    return updatedPrescriptions;
                });
            }
            else {
                saveTemplates(prevData =>
                    prevData.map(template => {
                        if (template.name == selectedTemplate.name) {
                            const updatedPrescriptions = [...template.medicines];
                            const { value, label, ...rest } = data;
                            updatedPrescriptions.push(rest)
                            setSelectedTemplate({ ...selectedTemplate, medicines: updatedPrescriptions })
                            return {
                                ...template,
                                medicines: updatedPrescriptions
                            };
                        }
                        return template;
                    })
                );
            }
        }
        else {
            setSymptomBasedPrescription(prevState => {
                const updatedPrescriptions = [...prevState];
                const { value, label, ...rest } = data;
                updatedPrescriptions.push(rest)
                return updatedPrescriptions;
            });
        }
    }

    const handleSavePrescription = () => {
        if (supplementchecked && (patientType !== "GYNECOLOGY" || isPreconception)) {
            store.dispatch(prescriptionAction.createPrescriptionRequestAction({
                patientId,
                "type": "SUPPLEMENT",
                consultationId,
                medicines: supplementPrescription
            }))
        }
        if (symptomChecked) {
            store.dispatch(prescriptionAction.createPrescriptionRequestAction({
                patientId,
                "type": "SYMPTOM_BASED",
                consultationId,
                medicines: symptomBasedPrescription
            }))
        }
    }

    const loadSupplementOptions = (inputValue) =>
        loadOptions(inputValue, "SUPPLEMENT");

    const loadSymptomOptions = (inputValue) =>
        loadOptions(inputValue, "SYMPTOM_BASED");

    const isPrescriptionChanged = () => {
        return (
            JSON.stringify(supplementPrescription) !== initialSupplement ||
            JSON.stringify(symptomBasedPrescription) !== initialSymptom
        );
    };

    const loadAdditionalTestOptions = async (inputValue) => {
        try {
            if (!inputValue || inputValue.length < 2) {
                return [];
            }

            const response = await API.get(
                `/v1/tests?pageNo=1&pageSize=20&search=${inputValue}`
            );

            if (!response.success) {
                return [];
            }

            return response.data?.map((item) => ({
                label: item.testName,
                value: item.id,
                testId: item.id,
                testName: item.testName,
                isAdditional: true
            })) || [];
        } catch (error) {
            console.error("Error loading tests:", error);
            return [];
        }
    };
    const isAlreadySubmitted =
        (initialSupplement?.length > 0) ||
        (initialSymptom?.length > 0);

    const renderTestLabel = (item) => {
        if (!item) return null;
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {item.testName}
                {item.memberRole === 'HIM' && <Male width={15} height={15} />}
                {item.memberRole === 'HER' && <Female width={15} height={15} />}
            </Box>
        );
    };

    const renderRecommendTest = () => {
        return <AsyncCreatableSelect
            cacheOptions
            defaultOptions={false}
            loadOptions={loadAdditionalTestOptions}
            placeholder="Add Test"
            menuPlacement="top"
            value={selectedAdditionalTest}
            onChange={(selectedOption) => {
                if (!selectedOption) return;
                setSelectedTests(prev =>
                    prev.includes(selectedOption.testId)
                        ? prev
                        : [...prev, selectedOption.testId]
                );
                setRecommendation(prev => ({
                    ...prev,
                    tests: [
                        ...(prev?.tests || []),
                        {
                            tenantTestId: selectedOption.testId,
                            testName: selectedOption.testName,
                            confidence: null,
                            reason: "Added by doctor",
                            isAdditional: true
                        }
                    ]
                }));
            }}
            onCreateOption={async (inputValue) => {
                try {
                    const payload = {
                        patientId,
                        consultationId,
                        testName: inputValue,
                        customValue: null,
                        category: "Other",
                    };
                    const response = await API.post(
                        "/v1/tests/custom",
                        payload
                    );
                    if (!response.success) {
                        return;
                    }
                    const createdTest = response.data;
                    setSelectedTests(prev =>
                        prev.includes(createdTest.id)
                            ? prev
                            : [...prev, createdTest.id]
                    );
                    setRecommendation(prev => ({
                        ...prev,
                        tests: [
                            ...(prev?.tests || []),
                            {
                                tenantTestId: test.id,
                                testName: test.testName,
                                confidence: null,
                                reason: "Added by doctor",
                                isAdditional: true
                            }
                        ]
                    }));
                } catch (error) {
                    console.error("Error creating custom test:", error);
                }
            }}
            styles={{
                ...styles.asyncSelect,
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 10000
                })
            }}
            menuPortalTarget={document.body}
        />
    }

    const renderContent = () => {
        const hasAdditionalTest = getTreatmentDetails?.nextAntenatalTests?.some(item => item.isAdditional);
        
        const renderTestCheckboxes = (testArray) => {
            if (!testArray || testArray.length === 0) return null;
            return testArray.map(test => (
                <FormControlLabel
                    key={test.tenantTestId}
                    sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' }, m: 0 }}
                    control={
                        <Checkbox
                            size="small"
                            color="black"
                            disabled={!edit}
                            checked={selectedTests.includes(test.tenantTestId)}
                            onChange={() => handleTestSelection(test.tenantTestId)}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: '15px' }, p: 0.5 }} 
                        />
                    }
                    label={test.testName}
                />
            ));
        };
        const renderTestsPreconception = (tests) => {
            const categories = [...new Set(tests.map(test => test?.category || 'Baseline panel — order today'))];
            if (categories.length === 0) {
                categories.push('Baseline panel — order today');
            }

            return (
                <Box mt={1}>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                            <Box sx={{ border: '1px solid #E5E7EB', borderRadius: '12px', p: 2, height: '100%', bgcolor: '#FFFFFF', textAlign: 'left' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                    <Chip label="Her" size="small" sx={{ bgcolor: 'pink', color: '#7E264F', fontWeight: 'bold', fontSize: '11px', height: '20px' }} />
                                    <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>Baseline panel — order today</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    {categories.map((category, index) => {
                                        const categoryTests = tests.filter(test => (test?.category || 'Baseline panel — order today') === category);
                                        const herTests = categoryTests.filter(test => test && (test.memberRole === 'HER' || !test.memberRole));
                                        
                                        if (herTests.length === 0 && tests.length > 0) return null;
                                        
                                        return (
                                            <Box key={`her-${index}`}>
                                                <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111827', mb: 1 }}>{category}</Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                    {renderTestCheckboxes(herTests)}
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                            <Box sx={{ border: '1px solid #E5E7EB', borderRadius: '12px', p: 2, height: '100%', bgcolor: '#FFFFFF', textAlign: 'left' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                    <Chip label="Him" size="small" sx={{ bgcolor: '#E3F2FD', color: '#1565C0', fontWeight: 'bold', fontSize: '11px', height: '20px' }} />
                                    <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111827' }}>Baseline panel — order today</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    {categories.map((category, index) => {
                                        const categoryTests = tests.filter(test => (test?.category || 'Baseline panel — order today') === category);
                                        const himTests = categoryTests.filter(test => test && test.memberRole === 'HIM');
                                        
                                        if (himTests.length === 0 && tests.length > 0) return null;

                                        return (
                                            <Box key={`him-${index}`}>
                                                <Typography sx={{ fontWeight: 600, fontSize: '14px', color: '#111827', mb: 1 }}>{category}</Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                    {renderTestCheckboxes(himTests)}
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    {edit && (
                        <Box  display="flex" justifyContent="flex-start">
                            <Box width="200px">
                                {renderRecommendTest()}
                            </Box>
                        </Box>
                    )}
                </Box>
            );
        };
        return <Grid container spacing={{ xs: 2, md: 3 }} sx={{
            height: {
                xs: 'auto',
                md: '78vh',
            },
        }}>
            <CommonGate showComplaint={false} />
            {isPreconception && <PreconceptionLeapPanel patientId={patientId} consultationId={consultationId} />}
            {hasPermission("PRESCRIPTION_VIEW") && <Grid size={{ xs: 12, md: 12, lg: 12, xl: 8 }}>
                <Grid container>
                    <Grid size={{ xs: 5, md: 2, lg: 2.5, xl: 2 }} alignSelf={'center'} >
                        <Typography variant='h6' textAlign={'left'} fontWeight={"bold"} sx={{ fontSize: { xl: '19px', lg: '16px', md: '14px' } }}>Prescription</Typography>
                    </Grid>
                    {edit && <Grid size={{ xs: 3, md: 3, lg: 3.5, xl: 2 }} sx={{ display: 'flex' }} justifyContent={'flex-start'} alignSelf='flex-start'>
                        <FormControlLabel
                            control={<IOSSwitch sx={{ m: 1 }} checked={checked} onChange={(e) => {
                                setChecked(e.target.checked)
                                setSupplementChecked(e.target.checked)
                                setSymptomChecked(e.target.checked)
                            }} />}
                        />
                    </Grid>}


                    {edit && selectedTemplate == null && prescriptionCreationPower && <Grid size={{ xs: 3, md: 7, lg: 6, xl: 8 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'center' }}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                handleSavePrescription()
                            }}
                            disabled={!(symptomChecked || supplementchecked) ||
                                (isAlreadySubmitted && !isPrescriptionChanged())}
                            sx={{
                                height: { lg: '16px', xl: '19px' }, minWidth: '58px', fontSize: { xs: '10px', md: '13px' }, backgroundColor: isAlreadySubmitted && !isPrescriptionChanged()
                                    ? "#9E9E9E"
                                    : "#F27704"
                            }}
                        >
                            {isAlreadySubmitted && !isPrescriptionChanged()
                                ? "Submitted"
                                : "Submit"}
                        </Button>
                    </Grid>}

                </Grid>
                <Grid container
                    sx={{
                        height: {
                            xs: 'auto',
                            md: '600px',
                        },
                        // boxShadow: '0 4px 4px rgba(0,0,0,0.25)',
                        // backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        border: "1px solid #E6E8EC",
                        borderRadius: '10px',
                        p: 0.5,
                        mt: 0.5
                    }}>
                    {(patientType !== "GYNECOLOGY" || isPreconception) && <Grid size={{ xs: 12, md: 12 }} sx={{ height: '49%' }}>
                        <Grid container spacing={1}>
                            <Grid size={{ xs: 4, md: 1.8, xl: 1.8, lg: 1.8 }}>
                                <Typography textAlign={'left'} sx={{ fontSize: { xl: '16px', lg: '15px', md: '13px' } }}>
                                    Supplements
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 2, md: 5.7 }} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                {edit &&
                                    <FormControlLabel
                                        control={<IOSSwitch sx={{ m: 1 }} checked={supplementchecked} onChange={(e) => checked && setSupplementChecked(e.target.checked)} />}
                                    />
                                }
                            </Grid>
                            <Grid size={{ xs: 3, md: 1.2 }} alignSelf={'center'}>
                                <Grid container spacing={1}>
                                    <Grid size={{ md: 4 }} >
                                        <WbTwilightIcon fontSize="small" />
                                    </Grid>
                                    <Grid size={{ md: 4 }}>
                                        <NightsStayOutlined fontSize="small" />
                                    </Grid>
                                    <Grid size={{ md: 4 }}>
                                        <BedtimeOutlined fontSize="small" />
                                    </Grid>

                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 2, md: 3 }} alignSelf={'center'}>
                                <Typography fontSize={'13px'}>
                                    Inst.  </Typography>
                            </Grid>
                            <Grid size={{ xs: 0, md: 0.8 }}>
                            </Grid>
                        </Grid>


                        {isMobile && <Grid container spacing={1}>
                            <Grid size={{ xs: 3, md: 4.4 }} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <Typography style={{ border: selectedTemplate == null ? '1px solid #E6E8EC' : 'none', borderRadius: '20px', textAlign: 'center', }} onClick={() => {
                                    setSelectedTemplate(null)
                                    // handleToggleMedicines(savedPrescription.length == 0 ? recommenedSupplementPrescription : savedPrescription)
                                    handleToggleMedicines(supplementPrescription)
                                }} sx={{ fontSize: { xl: '13px', lg: '10px', md: '9px', xs: '12px' }, width: { xl: '56.5px', lg: '50px', md: '45px', xs: '100px' }, height: { xl: '18px', lg: '16px', md: '13px' }, }}>
                                    Current
                                </Typography>
                            </Grid>
                            {
                                templates?.map((template) => {
                                    return <Grid size={{ xs: 2, md: 3.3 }} alignSelf={'center'}>
                                        <Typography onClick={() => {
                                            setSelectedTemplate(template)

                                        }} sx={{
                                            border: selectedTemplate && (template.name == selectedTemplate?.name) ? '1px solid #E6E8EC' : 'none',
                                            borderRadius: '20px',
                                            color: "black",
                                            fontSize: { xl: '13px', lg: '10px', md: '9px', xs: '12px' },
                                            width: { xl: '56px', lg: '40px', md: '35px' },
                                            height: { xl: '18px', lg: '15px', md: '13px' },
                                            // boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.15)'
                                        }} >
                                            {template.name}
                                        </Typography>
                                    </Grid>
                                })
                            }

                        </Grid>}

                        <Grid container spacing={1} sx={{ p: 0.5 }}>
                            {!isMobile && <Grid size={{ xs: 12, md: 1 }} sx={{}}>
                                <Grid item justifySelf={'center'}>
                                    <Typography style={{ border: selectedTemplate == null ? '1px solid #E6E8EC' : 'none', borderRadius: '20px', textAlign: 'center', }} onClick={() => {
                                        setSelectedTemplate(null)
                                        // handleToggleMedicines(savedPrescription.length == 0 ? recommenedSupplementPrescription : savedPrescription)
                                        handleToggleMedicines(supplementPrescription)
                                    }} sx={{ fontSize: { xl: '13px', lg: '10px', md: '9px' }, width: { xl: '56.5px', lg: '50px', md: '45px' }, height: { xl: '18px', lg: '16px', md: '13px' }, }}>
                                        Current
                                    </Typography>
                                </Grid>
                                {
                                    templates?.map((template) => {
                                        return <Grid item mt={1} justifySelf={'center'}>
                                            <Typography onClick={() => {
                                                setSelectedTemplate(template)

                                            }} sx={{
                                                border: selectedTemplate && (template.name == selectedTemplate?.name) ? '1px solid #E6E8EC' : 'none',
                                                borderRadius: '20px',
                                                color: "black",
                                                fontSize: { xl: '13px', lg: '10px', md: '9px' },
                                                width: { xl: '56px', lg: '40px', md: '35px' },
                                                height: { xl: '18px', lg: '15px', md: '13px' },
                                            }} >
                                                {template.name}
                                            </Typography>
                                        </Grid>
                                    })
                                }
                                {templates.length < 3 && <Grid item>
                                    <Typography onClick={() => {
                                        handleCreateTemplate()
                                    }}>
                                        +
                                    </Typography>
                                </Grid>}
                            </Grid>}

                            <Grid size={{ xs: 12, md: 11 }}>
                                <Box sx={{
                                    height: '251px',
                                    // boxShadow: '0 4px 4px rgba(0,0,0,0.25)',
                                    // backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                    borderRadius: '10px',
                                    border: '1px solid #E6E8EC'

                                }}>
                                    <Scrollbar gridTemplate="auto / 1fr 20px" padding="0 0rem" scrollerPadding="0rem" scrollerWidth="12px">
                                        <Box sx={{
                                            height: '217px',
                                            p: 0,
                                        }}>
                                            {selectedTemplate == null && (!prescriptionReducer.requestState ? supplementPrescription?.map((prescription, index) => {
                                                return <Grid container spacing={1} sx={{
                                                    ml: { xs: 1, md: 0 }, mt: 1, p: 0.5, backgroundColor: { xs: 'rgba(255, 255, 255, 0.3)', md: 'transparent', }, border: { xs: '1px solid #ddd', md: 'none' },
                                                    borderRadius: { xs: '12px', md: 0 },
                                                    // boxShadow: {xs:'0 4px 4px rgba(0,0,0,0.25)',md:'none'},
                                                }}>
                                                    <Grid size={{ xs: 12, md: 7.3 }}>
                                                        <Grid container spacing={1} >
                                                            <Grid size={{ xs: 6, md: 3.5 }} sx={{ alignItems: 'center', alignItems: 'flex-start', alignSelf: 'center' }}>
                                                                {edit ? (
                                                                    <TextField
                                                                        value={prescription.indication}
                                                                        placeholder="Add Indication"
                                                                        onChange={(e) => {
                                                                            handleChange("supplement", e.target.value, "indication", index)
                                                                        }
                                                                        }
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    border: "1px solid #E6E8EC",
                                                                                },
                                                                                '& input': {
                                                                                    fontSize: '12px',
                                                                                    height: '29px',
                                                                                    padding: '4px 6px',
                                                                                    backgroundColor: '#FFFF',
                                                                                    textAlign: 'center',
                                                                                    borderTopLeftRadius: 5,
                                                                                    borderBottomLeftRadius: 5
                                                                                },
                                                                            },
                                                                        }}
                                                                        disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                    />
                                                                ) : (
                                                                    <Typography
                                                                        fontWeight="bold"
                                                                        noWrap
                                                                        textAlign="left"
                                                                        sx={{
                                                                            ml: 1,
                                                                            fontSize: { xl: '13px', lg: '14px', md: '12px', xs: '11px' },
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        {prescription.indication || '-'}
                                                                    </Typography>
                                                                )}
                                                            </Grid>
                                                            <Grid size={{ xs: 6, md: 4 }}>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    defaultOptions={true}
                                                                    loadOptions={loadSupplementOptions}
                                                                    onChange={(selectedOption) => {
                                                                        handleChange("supplement", selectedOption, "drugName", index)
                                                                    }}
                                                                    styles={{ ...styles.asyncSelect, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                    value={{ label: prescription.drugName, value: prescription.drugName }}
                                                                    isDisabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ xs: 6, md: 4.5 }}>
                                                                <TextField
                                                                    value={prescription.description}
                                                                    placeholder="Add Description"
                                                                    onChange={(e) => {
                                                                        handleChange("supplement", e.target.value, "description", index)
                                                                    }
                                                                    }
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                border: "1px solid #E6E8EC",
                                                                            },
                                                                            '& input': {
                                                                                fontSize: '12px',
                                                                                height: '29px',
                                                                                padding: '4px 6px',
                                                                                backgroundColor: '#FFFF',
                                                                                textAlign: 'center',
                                                                                borderTopLeftRadius: 5,
                                                                                borderBottomLeftRadius: 5
                                                                            },
                                                                        },
                                                                    }}
                                                                    disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                />
                                                            </Grid>

                                                            {isMobile && <Grid size={{ xs: 6, md: 1.3 }}>
                                                                <Grid container spacing={1} sx={{ ml: { xs: 2 } }}>
                                                                    <Grid size={{ md: 4, xs: 3 }}>
                                                                        <FormControlLabel
                                                                            control={<Checkbox checked={prescription.morningDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", index, 'morningDose')} size="small" />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid size={{ md: 4, xs: 3 }}>
                                                                        <FormControlLabel
                                                                            control={<Checkbox checked={prescription.afternoonDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", index, 'afternoonDose')} size="small" />}
                                                                        />
                                                                    </Grid>
                                                                    <Grid size={{ md: 4, xs: 3 }}>
                                                                        <FormControlLabel
                                                                            control={<Checkbox checked={prescription.nightDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", index, 'nightDose')} size="small" />}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>}
                                                        </Grid>
                                                    </Grid>
                                                    {!isMobile && <Grid size={{ xs: 6, md: 1.3 }}>
                                                        <Grid container spacing={1} sx={{ ml: { xs: 2, md: 0 } }}>
                                                            <Grid size={{ md: 4, xs: 3 }}>
                                                                <FormControlLabel
                                                                    control={<Checkbox checked={prescription.morningDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", index, 'morningDose')} size="small" />}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 3 }}>
                                                                <FormControlLabel
                                                                    control={<Checkbox checked={prescription.afternoonDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", index, 'afternoonDose')} size="small" />}
                                                                />
                                                            </Grid>
                                                            <Grid size={{ md: 4, xs: 3 }}>
                                                                <FormControlLabel
                                                                    control={<Checkbox checked={prescription.nightDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", index, 'nightDose')} size="small" />}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>}
                                                    <Grid size={{ xs: 5, md: 1.8 }} sx={{ ml: { xs: 0.5, md: 0 } }}>
                                                        {renderInstruction("instruction", prescription.instruction, index)}
                                                    </Grid>
                                                    <Grid size={{ xs: 5, md: 1.5 }} sx={{ display: 'flex', flexDirection: 'row' }} alignItems={'center'}>
                                                        <Box sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            width: '100%',
                                                            borderRadius: '12px',
                                                            ml: { xs: 2.5, md: 0 },
                                                            border: "1px solid #E6E8EC"
                                                        }}>
                                                            <TextField
                                                                style={{
                                                                    width: '34px'
                                                                }}
                                                                value={prescription.duration}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
                                                                        handleChange("supplement", value == "" ? 0 : parseInt(e.target.value), "duration", index)
                                                                    }
                                                                }
                                                                }
                                                                placeholder="00"
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            border: 'none',
                                                                        },
                                                                        '& input': {
                                                                            fontSize: '12px',
                                                                            height: '29px',
                                                                            padding: '4px 6px',
                                                                            // backgroundColor: '#FFFF',
                                                                            textAlign: 'center',
                                                                            borderTopLeftRadius: 5,
                                                                            borderBottomLeftRadius: 5
                                                                        },
                                                                    },
                                                                }}
                                                                disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                            />
                                                            {renderDuration("durationUnit", prescription.durationUnit, index)}
                                                        </Box>

                                                        {edit && <Tooltip title="Delete">
                                                            <DeleteOutline fontSize="small" sx={{
                                                                cursor: 'pointer'
                                                            }} onClick={() => deleteMedicine(index)} />
                                                        </Tooltip>}

                                                    </Grid>
                                                </Grid>
                                            })
                                                :
                                                <CircularProgress />)

                                            }
                                            {
                                                selectedTemplate !== null && selectedTemplate?.medicines?.map((medicine, medIndex) => {
                                                    return <Grid container spacing={1} sx={{
                                                        ml: { xs: 1, md: 0 }, mt: 1, p: 0.5, backgroundColor: { xs: 'rgba(255, 255, 255, 0.3)', md: 'transparent', }, border: { xs: '1px solid #ddd', md: 'none' },
                                                        borderRadius: { xs: '12px', md: 0 },
                                                        // boxShadow: {xs:'0 4px 4px rgba(0,0,0,0.25)',md:'none'},
                                                    }}>
                                                        <Grid size={{ xs: 12, md: 7.3 }}>
                                                            <Grid container spacing={1}>
                                                                <Grid size={{ xs: 6, md: 3.5 }} sx={{ alignItems: 'flex-start', alignSelf: 'center' }}>
                                                                    {edit ? <TextField
                                                                        value={medicine.indication}
                                                                        placeholder="Add Indication"
                                                                        onChange={(e) => {
                                                                            handleChange("supplement", e.target.value, "indication", medIndex)
                                                                        }
                                                                        }
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    border: "1px solid #E6E8EC",
                                                                                },
                                                                                '& input': {
                                                                                    fontSize: '12px',
                                                                                    height: '29px',
                                                                                    padding: '4px 6px',
                                                                                    // backgroundColor: '#FFFF',
                                                                                    textAlign: 'center',
                                                                                    borderTopLeftRadius: 5,
                                                                                    borderBottomLeftRadius: 5
                                                                                },
                                                                            },
                                                                        }}
                                                                        disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                    /> :
                                                                        <Typography fontWeight={'bold'} noWrap textAlign={'left'} sx={{
                                                                            ml: 1, fontSize: { xl: '13px', lg: '14px', md: '12px', xs: '11px' },
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                        }} >
                                                                            {medicine.indication}
                                                                        </Typography>
                                                                    }
                                                                </Grid>
                                                                <Grid size={{ xs: 6, md: 4 }}>
                                                                    <AsyncSelect
                                                                        cacheOptions
                                                                        defaultOptions={true}
                                                                        loadOptions={loadSupplementOptions}
                                                                        onChange={(selectedOption) => {
                                                                            handleChange("supplement", selectedOption, "drugName", medIndex,)
                                                                        }}
                                                                        isDisabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                        styles={{ ...styles.asyncSelect, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                        value={{ label: medicine.drugName, value: medicine.drugName }}
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </Grid>
                                                                <Grid size={{ xs: 6, md: 4.5 }}>
                                                                    <TextField
                                                                        value={medicine.description}
                                                                        placeholder="Add Description"
                                                                        onChange={(e) => {
                                                                            handleChange("supplement", e.target.value, "description", medIndex)
                                                                        }
                                                                        }
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    border: "1px solid #E6E8EC",
                                                                                },
                                                                                '& input': {
                                                                                    fontSize: '12px',
                                                                                    height: '29px',
                                                                                    padding: '4px 6px',
                                                                                    backgroundColor: '#FFFF',
                                                                                    textAlign: 'center',
                                                                                    borderTopLeftRadius: 5,
                                                                                    borderBottomLeftRadius: 5
                                                                                },
                                                                            },
                                                                        }}
                                                                        disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                    />
                                                                </Grid>

                                                                {isMobile && <Grid size={{ xs: 6, md: 1.3 }}>
                                                                    <Grid container spacing={1} sx={{ ml: { xs: 2 } }}>
                                                                        <Grid size={{ md: 4, xs: 3 }} >
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={medicine.morningDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", medIndex, 'morningDose')} size="small" />}
                                                                            />
                                                                        </Grid>
                                                                        <Grid size={{ md: 4, xs: 3 }}>
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={medicine.afternoonDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", medIndex, 'afternoonDose')} size="small" />}
                                                                            />
                                                                        </Grid>
                                                                        <Grid size={{ md: 4, xs: 3 }}>
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={medicine.nightDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", medIndex, 'nightDose')} size="small" />}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>}
                                                            </Grid>
                                                        </Grid>
                                                        {!isMobile && <Grid size={{ xs: 6, md: 1.3 }}>
                                                            <Grid container spacing={1} sx={{ ml: { xs: 2, md: 0 } }}>
                                                                <Grid size={{ md: 4, xs: 3 }} >
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={medicine.morningDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", medIndex, 'morningDose')} size="small" />}
                                                                    />
                                                                </Grid>
                                                                <Grid size={{ md: 4, xs: 3 }}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={medicine.afternoonDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", medIndex, 'afternoonDose')} size="small" />}
                                                                    />
                                                                </Grid>
                                                                <Grid size={{ md: 4, xs: 3 }}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={medicine.nightDose == 1} color="black" disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower} onChange={() => handleChangeDosage("supplement", medIndex, 'nightDose')} size="small" />}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>}
                                                        <Grid size={{ xs: 5, md: 1.8 }} sx={{ ml: { xs: 0.5, md: 0 } }}>
                                                            {renderInstruction("instruction", medicine.instruction, medIndex)}
                                                        </Grid>
                                                        <Grid size={{ xs: 5, md: 1.5 }} sx={{ display: 'flex', flexDirection: 'row' }} alignItems={'center'}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                width: '100%',
                                                                borderRadius: '12px',
                                                                ml: { xs: 2.5, md: 0 }
                                                                , border: "1px solid #E6E8EC"
                                                            }}>
                                                                <TextField
                                                                    style={{
                                                                        // boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
                                                                        width: '50%'
                                                                    }}
                                                                    value={medicine.duration}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
                                                                            handleChange("supplement", value == "" ? 0 : parseInt(e.target.value), "duration", medIndex)
                                                                        }
                                                                    }}
                                                                    placeholder="00"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                border: 'none',
                                                                            },
                                                                            '& input': {
                                                                                fontSize: '12px',
                                                                                height: '14px',
                                                                                padding: '10px',
                                                                                // backgroundColor: '#FFFF'
                                                                            },
                                                                        },
                                                                    }}
                                                                    disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                />
                                                                {renderDuration("durationUnit", medicine.durationUnit, medIndex)}
                                                            </Box>

                                                            {edit && <DeleteOutline fontSize="small" sx={{
                                                                cursor: 'pointer'
                                                            }} onClick={() => deleteMedicine(medIndex)} />}

                                                        </Grid>
                                                    </Grid>
                                                })
                                            }
                                            {edit && !prescriptionReducer.requestState && <Grid container spacing={2} mt={1} >
                                                <Grid size={{ xs: 12, md: 2.15 }} />
                                                <Grid size={{ xs: 12, md: 3.5 }} sx={{ ml: { xs: 1, md: 0 } }}>
                                                    <AsyncCreatableSelect
                                                        cacheOptions
                                                        defaultOptions={true}
                                                        loadOptions={loadSupplementOptions}
                                                        onChange={(selectedOption) => {
                                                            handleAddMedicine(selectedOption)
                                                            setSelectedOption(null);
                                                        }}
                                                        value={selectedOption}
                                                        placeholder="Add Medicine"
                                                        styles={{ ...styles.asyncSelect, menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                        menuPortalTarget={document.body}
                                                        isDisabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                        onCreateOption={async (inputValue) => {
                                                            const payload = {
                                                                "drugName": inputValue,
                                                                "type": "SUPPLEMENT"
                                                            }
                                                            const response = await API.post(
                                                                "v1/hospitals/medicines",
                                                                payload
                                                            );
                                                            if (!response.success) {
                                                                showToast(`${response?.errors?.error || 'Something went wrong'}`, "error");
                                                                return;
                                                            }
                                                            handleAddMedicine({
                                                                afternoonDose: response.data.afternoonDose,
                                                                description: response.data.description,
                                                                doseUnit: response.data.doseUnit,
                                                                drugName: response.data.drugName,
                                                                duration: response.data.duration,
                                                                durationUnit: response.data.durationUnit,
                                                                indication: response.data.indication || '',
                                                                medicineId: response.data.id,
                                                                morningDose: response.data.morningDose,
                                                                nightDose: response.data.nightDose
                                                            })
                                                            setSelectedOption(null);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6.3 }} />
                                            </Grid>}

                                        </Box>
                                    </Scrollbar>
                                    {
                                        selectedTemplate !== null && edit && prescriptionCreationPower &&
                                        <>
                                            <Grid container spacing={1}>
                                                <Grid item size={{ xs: 4, md: 2.3 }} />
                                                <Grid item size={{ xs: 4, md: 3.2 }}>

                                                </Grid>
                                                <Grid item size={{ xs: 6, md: 4 }} sx={{ display: 'flex', justifyContent: 'flex-end', }} >
                                                    <Button
                                                        variant="contained"
                                                        disabled={!edit || !checked || !supplementchecked}
                                                        sx={{ height: { md: '19px', lg: '19px', xl: '19px', xs: '15px' }, width: '58px', fontSize: { md: '13px', xs: '11px' }, backgroundColor: '#F27704' }}
                                                        onClick={() => {
                                                            updateTemplate(selectedTemplate)
                                                        }} >
                                                        Save
                                                    </Button>
                                                </Grid>
                                                <Grid item size={{ xs: 6, md: 2 }} sx={{ display: 'flex', justifyContent: 'center' }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        disabled={!edit || !checked || !supplementchecked}
                                                        sx={{ height: { md: '19px', lg: '19px', xl: '19px', xs: '15px' }, width: '58px', fontSize: { md: '13px', xs: '11px' }, backgroundColor: '#F27704' }}
                                                        onClick={() => {
                                                            setSupplementPrescription(selectedTemplate.medicines)
                                                            setSelectedTemplate(null)
                                                        }} >
                                                        Select
                                                    </Button>
                                                </Grid>
                                                <Grid item size={{ xs: 12, md: 0.5 }}>
                                                </Grid>
                                            </Grid>
                                        </>
                                    }
                                </Box>
                            </Grid>

                        </Grid>
                    </Grid>}

                    <Grid size={{ xs: 12, md: 12 }} sx={{ height: '90%', mt: 1 }}>
                        <Grid size={{ xs: 12, md: 12 }} sx={{ height: '49%' }}>
                            <Grid container sx={{}} spacing={1} >
                                <Grid size={{ xs: 4, md: 1.4 }} alignSelf={'center'}>
                                    <Typography textAlign={'left'} sx={{ fontSize: { xl: '16px', lg: '15px', md: '13px' } }}>
                                        Symptoms
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 2, md: 6.1 }} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                                    {edit &&
                                        <FormControlLabel
                                            control={<IOSSwitch sx={{ m: 1 }} checked={symptomChecked} onChange={(e) => checked && setSymptomChecked(e.target.checked)} />}
                                        />
                                    }
                                </Grid>
                                <Grid size={{ xs: 3, md: 1.2 }} alignSelf={'center'}>
                                    <Grid container spacing={1}>
                                        <Grid size={{ md: 4 }} >
                                            <WbTwilightIcon fontSize="small" />
                                        </Grid>
                                        <Grid size={{ md: 4 }}>
                                            <NightsStayOutlined fontSize="small" />
                                        </Grid>
                                        <Grid size={{ md: 4 }}>
                                            <BedtimeOutlined fontSize="small" />
                                        </Grid>

                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 2, md: 3 }} alignSelf={'center'}>
                                    <Typography fontSize={'13px'}>
                                        Inst.  </Typography>
                                </Grid>
                                <Grid size={{ xs: 0, md: 0.8 }}>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1} sx={{ p: 0.5 }}>
                                <Grid size={{ xs: 0, md: 1 }} sx={{}}>
                                    <Grid item />
                                </Grid>

                                <Grid size={{ xs: 12, md: 11 }}>
                                    <Box sx={{
                                        height: (patientType !== "GYNECOLOGY" || isPreconception) ? '248px' : '535px',
                                        // boxShadow: '0 4px 4px rgba(0,0,0,0.25)',
                                        // backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                        borderRadius: '10px',
                                        border: "1px solid #E6E8EC"
                                    }}>
                                        <Scrollbar gridTemplate="auto / 1fr 20px" padding="0 0rem" scrollerPadding="0rem" scrollerWidth="12px">
                                            <Box sx={{
                                                height: (patientType !== "GYNECOLOGY" || isPreconception) ? '230px' : '520px',
                                                p: 0,
                                            }}>
                                                {!prescriptionReducer.requestState ? symptomBasedPrescription?.map((prescription, index) => {
                                                    return <Grid container spacing={1} sx={{
                                                        ml: { xs: 1, md: 0 }, mt: 1, p: 0.5, backgroundColor: { xs: 'rgba(255, 255, 255, 0.3)', md: 'transparent', }, border: { xs: '1px solid #ddd', md: 'none' },
                                                        borderRadius: { xs: '12px', md: 0 },
                                                        // boxShadow: {xs:'0 4px 4px rgba(0,0,0,0.25)',md:'none'},
                                                    }}>
                                                        <Grid size={{ xs: 12, md: 7.3 }}>
                                                            <Grid container spacing={1}>
                                                                <Grid size={{ xs: 6, md: 3.5 }} sx={{ alignItems: 'center', alignItems: 'flex-start', alignSelf: 'center' }}>
                                                                    {edit ?
                                                                        <TextField
                                                                            value={prescription.indication}
                                                                            placeholder="Add Indication"
                                                                            onChange={(e) => {
                                                                                handleChange("symptom", e.target.value, "indication", index)
                                                                            }
                                                                            }
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '& fieldset': {
                                                                                        border: "1px solid #E6E8EC",
                                                                                    },
                                                                                    '& input': {
                                                                                        fontSize: '12px',
                                                                                        height: '29px',
                                                                                        padding: '4px 6px',
                                                                                        backgroundColor: '#FFFF',
                                                                                        textAlign: 'center',
                                                                                        borderTopLeftRadius: 5,
                                                                                        borderBottomLeftRadius: 5
                                                                                    },
                                                                                },
                                                                            }}
                                                                            disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                        />
                                                                        :
                                                                        <Typography fontWeight={'bold'} noWrap textAlign={'left'} sx={{
                                                                            ml: 1, fontSize: { xl: '13px', lg: '14px', md: '12px', xs: '11px' },
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                        }} >{prescription.indication}</Typography>
                                                                    }
                                                                </Grid>
                                                                <Grid size={{ xs: 6, md: 4 }}>
                                                                    <AsyncSelect
                                                                        cacheOptions
                                                                        defaultOptions={true}
                                                                        loadOptions={loadSymptomOptions}
                                                                        onChange={(selectedOption) => {
                                                                            handleChange("symptom", selectedOption, "drugName", index)
                                                                        }}
                                                                        styles={styles.asyncSelect}
                                                                        isDisabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower}
                                                                        value={{ label: prescription.drugName, value: prescription.drugName }}
                                                                    />
                                                                </Grid>
                                                                <Grid size={{ xs: 6, md: 4.5 }}>
                                                                    <TextField
                                                                        value={prescription.description}
                                                                        placeholder="Add Description"
                                                                        onChange={(e) => {
                                                                            handleChange("symptom", e.target.value, "description", index)
                                                                        }
                                                                        }
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    border: "1px solid #E6E8EC",
                                                                                },
                                                                                '& input': {
                                                                                    fontSize: '12px',
                                                                                    height: '29px',
                                                                                    padding: '4px 6px',
                                                                                    backgroundColor: '#FFFF',
                                                                                    textAlign: 'center',
                                                                                    borderTopLeftRadius: 5,
                                                                                    borderBottomLeftRadius: 5
                                                                                },
                                                                            },
                                                                        }}
                                                                        disabled={!edit || !checked || !supplementchecked || !prescriptionCreationPower}
                                                                    />
                                                                </Grid>

                                                                {isMobile && <Grid size={{ xs: 6, md: 1.3 }}>
                                                                    <Grid container spacing={1} sx={{ ml: { xs: 2 } }}>
                                                                        <Grid size={{ md: 4, xs: 3 }} >
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={prescription.morningDose == 1} disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower} color="black" onChange={() => handleChangeDosage("symptom", index, 'morningDose')} size="small" />}
                                                                            />
                                                                        </Grid>
                                                                        <Grid size={{ md: 4, xs: 3 }}>
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={prescription.afternoonDose == 1} disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower} color="black" onChange={() => handleChangeDosage("symptom", index, 'afternoonDose')} size="small" />}
                                                                            />
                                                                        </Grid>
                                                                        <Grid size={{ md: 4, xs: 3 }}>
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={prescription.nightDose == 1} disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower} color="black" onChange={() => handleChangeDosage("symptom", index, 'nightDose')} size="small" />}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>}
                                                            </Grid>
                                                        </Grid>
                                                        {!isMobile && <Grid size={{ xs: 6, md: 1.3 }}>
                                                            <Grid container spacing={1} sx={{ ml: { xs: 2, md: 0 } }}>
                                                                <Grid size={{ md: 4, xs: 3 }} >
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={prescription.morningDose == 1} disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower} color="black" onChange={() => handleChangeDosage("symptom", index, 'morningDose')} size="small" />}
                                                                    />
                                                                </Grid>
                                                                <Grid size={{ md: 4, xs: 3 }}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={prescription.afternoonDose == 1} disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower} color="black" onChange={() => handleChangeDosage("symptom", index, 'afternoonDose')} size="small" />}
                                                                    />
                                                                </Grid>
                                                                <Grid size={{ md: 4, xs: 3 }}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={prescription.nightDose == 1} disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower} color="black" onChange={() => handleChangeDosage("symptom", index, 'nightDose')} size="small" />}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>}
                                                        <Grid size={{ xs: 5, md: 1.8 }} sx={{ ml: { xs: 0.5, md: 0 } }}>
                                                            {renderInstruction("instruction", prescription.instruction, index, "symptom")}
                                                        </Grid>
                                                        <Grid size={{ xs: 5, md: 1.5 }} sx={{ display: 'flex', flexDirection: 'row' }} alignItems={'center'}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                width: '100%',
                                                                borderRadius: '12px',
                                                                ml: { xs: 2.5, md: 0 }, border: "1px solid #E6E8EC"
                                                            }}>
                                                                <TextField
                                                                    style={{
                                                                        // boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
                                                                        width: '50%'
                                                                    }}
                                                                    value={prescription.duration}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) { handleChange("symptom", value == "" ? 0 : parseInt(e.target.value), "duration", index) }
                                                                    }}
                                                                    placeholder="00"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            '& fieldset': {
                                                                                border: 'none',
                                                                            },
                                                                            '& input': {
                                                                                fontSize: '12px',
                                                                                height: '14px',
                                                                                padding: '10px',
                                                                                // backgroundColor: '#FFFF'
                                                                            },
                                                                        },
                                                                    }}
                                                                    disabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower}
                                                                />
                                                                {renderDuration("durationUnit", prescription.durationUnit, index, "symptom")}
                                                            </Box>

                                                            {edit && <DeleteOutline fontSize="small" sx={{
                                                                cursor: 'pointer'
                                                            }} onClick={() => deleteMedicine(index, "symptom",)} />}

                                                        </Grid>
                                                    </Grid>
                                                })
                                                    :
                                                    <CircularProgress />
                                                }

                                                {edit && <Grid container spacing={2} mt={1} >
                                                    <Grid size={{ xs: 12, md: 2.15 }} />
                                                    <Grid size={{ xs: 12, md: 3.5 }} sx={{ ml: { xs: 1, md: 0 } }}>
                                                        <AsyncCreatableSelect
                                                            cacheOptions
                                                            defaultOptions={true}
                                                            loadOptions={loadSymptomOptions}
                                                            onChange={(selectedOption) => {
                                                                handleAddMedicine(selectedOption, "symptom")
                                                                setSelectedOption(null);
                                                            }}
                                                            value={selectedOption}
                                                            placeholder="Add Medicine"
                                                            isDisabled={!edit || !checked || !symptomChecked || !prescriptionCreationPower}
                                                            styles={styles.asyncSelect}
                                                            onCreateOption={async (inputValue) => {
                                                                const payload = {
                                                                    "drugName": inputValue,
                                                                    "type": "SYMPTOM_BASED"
                                                                }
                                                                const response = await API.post(
                                                                    "v1/hospitals/medicines",
                                                                    payload
                                                                );
                                                                if (!response.success) {
                                                                    showToast(`${response?.errors?.error || 'Something went wrong'}`, "error");
                                                                    return;
                                                                }
                                                                handleAddMedicine({
                                                                    afternoonDose: response.data.afternoonDose,
                                                                    description: response.data.description,
                                                                    doseUnit: response.data.doseUnit,
                                                                    drugName: response.data.drugName,
                                                                    duration: response.data.duration,
                                                                    durationUnit: response.data.durationUnit,
                                                                    indication: response.data.indication || '',
                                                                    medicineId: response.data.id,
                                                                    morningDose: response.data.morningDose,
                                                                    nightDose: response.data.nightDose
                                                                }, "symptom")
                                                                setSelectedOption(null);
                                                            }}
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, md: 6.3 }} />
                                                </Grid>}

                                            </Box>
                                        </Scrollbar>
                                    </Box>
                                </Grid>

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </Grid>}

            <Grid size={{ xs: 12, md: 12, lg: 12, xl: 4 }}>
                <Stack>
                    <Grid item>
                        <Typography textAlign={'left'} fontWeight={"bold"} fontSize={'19px'}>Doctor Notes</Typography>
                        <Box sx={{
                            height: '300px',
                            // boxShadow: '0 4px 4px rgba(0,0,0,0.25)',
                            // backgroundColor: 'rgba(255, 255, 255, 0.3)',
                            border: '1px solid #E6E8EC',
                            borderRadius: '10px',
                            p: 1,
                            overflow: "hidden",
                            position: 'relative',
                        }}>
                            <Box sx={{ ...styles.fixedBox, height: showPastWeeks ? '65px' : '260px', }} />
                            <Typography variant="h6" textAlign={'left'}
                                style={{
                                    cursor: "pointer",
                                    justifySelf: 'end',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    marginRight: 55
                                }}
                                onClick={handleCurrentTestsClick}
                            >
                                {patientType !== "GYNECOLOGY"? formatWeeks(currentTreatment?.[0]?.week): currentTreatment?.[0]?.createdAt ? moment(currentTreatment?.[0]?.createdAt).format('DD-MM-YYYY'):''}
                            </Typography>

                            <Box sx={{ height: "260px", overflow: "hidden" }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: '240px',
                                        flexWrap: "wrap",
                                        overflowY: "auto",
                                        scrollbarWidth: "thin",
                                    }}
                                    ref={currentObservationRef}
                                >
                                    <Scrollbar scrollerWidth="8px">
                                        <TextField
                                            fullWidth
                                            placeholder="Observations"
                                            style={{
                                                backgroundColor: '#F9F9F9',
                                                borderRadius: '10px',
                                            }}
                                            multiline
                                            value={updateTreatment.observations}
                                            onChange={(event) => {
                                                // setCurrentTreatment(
                                                // (prevData => {
                                                //     const updatedData = [...prevData]
                                                //     updatedData[0] = {
                                                //         ...updatedData[0],
                                                //         observations: event.target.value
                                                //     }
                                                //     return updatedData
                                                // }
                                                // ))
                                                setUpdateTreatment(prev => ({
                                                    ...prev,
                                                    observations: event.target.value
                                                }));
                                            }
                                            }
                                            disabled={!edit}
                                            rows={7}
                                            sx={{
                                                height: '260px',
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        border: 'none',
                                                    },
                                                    '& input::placeholder': {
                                                        fontSize: '12px',
                                                    },
                                                },
                                            }}
                                        />
                                    </Scrollbar>
                                </Box>

                                {!showPastWeeks && currentTreatment.length > 1 && <Typography variant="h6" onClick={() => {
                                    setPastWeeks(!showPastWeeks)
                                    if (selectedWeekRef.current) {
                                        selectedWeekRef.current.scrollIntoView({
                                            behavior: "smooth",
                                            block: "nearest"
                                        });
                                    }
                                }}
                                    style={{
                                        cursor: "pointer",
                                        justifySelf: 'end',
                                        fontSize: '13px',
                                        marginRight: 50
                                    }}>
                                    Past Obs
                                </Typography>}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: 1,
                                        flexWrap: 'wrap',
                                        overflowY: 'hidden',
                                        scrollbarWidth: 'thin',
                                        '& > *': {
                                            // flex: '1 1 270px', 
                                            // minWidth: '270px' 
                                        },
                                        '@media (maxWidth: 600px)': {
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        },
                                        height: "240px",
                                        paddingBottom:'20px'
                                    }}
                                >
                                    {!showPastWeeks && currentTreatment.length > 1 && <Box sx={{
                                        position: 'absolute',
                                        top: 250,
                                        right: 18,
                                        height: "45px",
                                        width: 5,
                                        bgcolor: '#5681A6',
                                        transition: "background-color 0.3s ease"
                                    }} />}
                                    <Scrollbar scrollerWidth="8px">
                                        {showPastWeeks && <Box sx={{
                                            position: 'absolute',
                                            right: 9,
                                            height: showPastWeeks ? '230px' : "125px",
                                            width: 5,
                                            bgcolor: '#5681A6',
                                            transition: "background-color 0.3s ease"
                                        }} />}
                                        {<Box
                                            ref={selectedWeekRef}
                                            sx={{ height: '240px', }}
                                        >
                                            {showPastWeeks && currentTreatment?.slice(1)?.map((item) => (
                                                <>
                                                    <Typography textAlign={'right'} variant="h6" sx={{
                                                        fontSize: '15px',
                                                        mt: 1
                                                    }}>
                                                        {patientType !== "GYNECOLOGY"? formatWeeks(item.week) || "" : item?.createdAt ? moment(item?.createdAt).format('DD-MM-YYYY') :''}
                                                    </Typography>
                                                    <TextField
                                                        style={{
                                                            // boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
                                                            backgroundColor: '#F2F2F2',
                                                            borderRadius: '10px',
                                                        }}
                                                        fullWidth
                                                        value={item?.observations}
                                                        disabled
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': {
                                                                    border: 'none',
                                                                },
                                                                '& input::placeholder': {
                                                                    fontSize: '12px',
                                                                },

                                                            },
                                                            width: { xl: '26.5vw', lg: '66vw', md: '60.5vw', xs: '69vw' }
                                                        }}
                                                    />
                                                </>
                                            ))}
                                        </Box>}
                                    </Scrollbar>
                                </Box>
                            </Box>

                        </Box>
                    </Grid>
                    <Grid item mt={1}>
                        <Box sx={{ display: 'flex', flexDirection: 'row' }} alignItems={'center'}>
                            <Typography textAlign={'left'} fontWeight={"bold"} fontSize={'19px'}>Follow Up</Typography>
                            {edit && <FormControlLabel
                                control={<IOSSwitch sx={{ ml: 3 }} checked={followUpChecked} onChange={(e) => {
                                    setFollowUpChecked(e.target.checked)
                                }} />}
                            />
                            }
                        </Box>

                        <Box onClick={() => inputRef.current && inputRef.current.showPicker()}>
                            <FollowUpWeekPicker
                                edit={edit}
                                updateTreatment={updateTreatment}
                                setUpdateTreatment={setUpdateTreatment}
                                date={updateTreatment.followUpTestDate}
                            />
                        </Box>

                        <TextField
                            fullWidth
                            placeholder="Remarks for Patient"
                            style={{
                                // boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
                                // backgroundColor: '#FFFF',
                                borderRadius: '5px',
                            }}
                            multiline
                            value={updateTreatment.followUpTestRemarks}
                            rows={2}
                            onChange={(e) => {
                                setUpdateTreatment(prev => ({
                                    ...prev,
                                    followUpTestRemarks: e.target.value
                                }));
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        border: '1px solid #E6E8EC',
                                    },
                                    '& input::placeholder': {
                                        fontSize: '12px',
                                    },
                                },
                                mt: 1
                            }}
                            disabled={!edit || !followUpChecked}
                        />

                        <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 1 }}>
                            <Grid container justifyContent="flex-start" alignItems="flex-start">
                                {edit && consultationReducer?.followUp?.slice(0, 6)?.map((item, index) => (
                                    <Grid size={{ xs: 6, md: 4 }} key={index} textAlign={'left'} >
                                        <FormControlLabel
                                            control={<Checkbox
                                                size="small"
                                                color="black"
                                                disabled={!followUpChecked}
                                                checked={updateTreatment?.followUpTests?.some(test => test.testId === item.testId) ? true : false}
                                                onChange={() => {
                                                    const isChecked = updateTreatment?.followUpTests?.some(test => test.testId === item.testId);
                                                    if (!updateTreatment.followUpTests) {
                                                        updateTreatment.followUpTests = []
                                                    }
                                                    const updatedFollowUpTests = isChecked
                                                        ? updateTreatment.followUpTests.filter(test => test.testId !== item.testId) // Remove
                                                        : [...updateTreatment.followUpTests, { testId: item.testId }]; // Add

                                                    setUpdateTreatment(prev => ({
                                                        ...prev,
                                                        followUpTests: updatedFollowUpTests
                                                    }));
                                                }}
                                            />}
                                            label={renderTestLabel(item)}
                                        />
                                    </Grid>
                                ))}
                                {!edit && getTreatmentDetails?.followUpTests?.slice(0, 7)?.map((item, index) => (
                                    <Grid size={{ xs: 6, md: 3 }} key={index} textAlign={'left'}>
                                        <FormControlLabel
                                            control={<Checkbox
                                                size="small"
                                                color="black"
                                                checked={true}
                                                disabled={true}
                                            />}
                                            label={renderTestLabel(item)}
                                        />
                                    </Grid>
                                ))}
                                {/* <Button variant="outlined">Add More</Button> */}
                            </Grid>
                        </Grid>

                    </Grid>
                </Stack>
            </Grid>

            {(patientType !== "GYNECOLOGY" && hasPermission('TREATMENT_CREATE') && consultationReducer?.nextConsultationInfo?.antenatalTests?.length > 0) && <Grid size={{ xs: 12, xl: 5, lg: 12, md: 12 }}>
                {<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography fontSize={{ xs: '14px', md: '18px' }}>Next Antenatal Test</Typography>
                    <Typography sx={{
                        ml: 4
                    }} fontSize={'13px'}>
                        Week {consultationReducer?.nextConsultationInfo?.week} ({consultationReducer?.nextConsultationInfo?.startWeek}wk 0dy - {consultationReducer?.nextConsultationInfo?.endWeek}wk 0dy)
                    </Typography>
                </Box>}

                <Grid container justifyContent="flex-start" alignItems="flex-start" sx={{
                    border: '1px solid #E6E8EC',
                    borderRadius: '10px',
                    p: 1,
                    mb: consultationReducer?.nextAdditionalTests.length == 0 ? '4px' : '4px'
                }}>
                    {edit && consultationReducer?.nextConsultationInfo?.antenatalTests?.map((item, index) => (
                        <Grid size={{ xs: 6, md: consultationReducer?.nextAdditionalTests.length == 0 ? 2 : 3, xl: 4 }} key={index} textAlign={'left'} >
                            <FormControlLabel
                                control={<Checkbox size="small" color="black"
                                    checked={updateTreatment?.nextAntenatalTests?.some(test => test.testId === item.testId) ? true : false}
                                    onChange={() => {
                                        const isChecked = updateTreatment?.nextAntenatalTests?.some(test => test.testId === item.testId);
                                        if (!updateTreatment.nextAntenatalTests) {
                                            updateTreatment.nextAntenatalTests = []
                                        }
                                        const updatedNextAntenatalTests = isChecked
                                            ? updateTreatment.nextAntenatalTests.filter(test => test.testId !== item.testId) // Remove
                                            : [...updateTreatment.nextAntenatalTests, { testId: item.testId, "isAdditional": false }]; // Add

                                        setUpdateTreatment(prev => ({
                                            ...prev,
                                            nextAntenatalTests: updatedNextAntenatalTests
                                        }));
                                    }}
                                />
                                }
                                label={renderTestLabel(item)}
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        fontSize: '12px',
                                    },
                                }}
                            />
                        </Grid>
                    ))}

                    {!edit && getTreatmentDetails?.nextAntenatalTests?.map((item, index) => (
                        !item.isAdditional && <Grid size={{ xs: 6, md: 3 }} key={index} textAlign={'left'} >
                            <FormControlLabel
                                control={<Checkbox
                                    size="small"
                                    color="black"
                                    checked={true}
                                    disabled={true}
                                />}
                                label={renderTestLabel(item)}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>}

            {(hasPermission('TREATMENT_CREATE') && (edit || (!edit && hasAdditionalTest))) && <Grid size={{ xs: 12, xl: 7, lg: 12, md: 12 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography fontSize={'18px'}>Additional Test</Typography>
                </Box>

                <Grid container justifyContent="flex-start" alignItems="flex-start" sx={{
                    border: '1px solid #E6E8EC',
                    borderRadius: '10px',
                    p: 1,
                    mb: '4px'
                }}>
                    {edit && [
                        ...(consultationReducer?.nextAdditionalTests || []),

                        ...((updateTreatment?.nextAntenatalTests || [])
                            .filter((item) => item.isAdditional))
                    ]
                        .filter(
                            (item, index, self) =>
                                index ===
                                self.findIndex(
                                    (t) =>
                                        (t.testId || t.id) === (item.testId || item.id)
                                )
                        )?.map((item, index) => (
                            <Grid size={{ xs: 6, md: 3 }} key={index} textAlign={'left'} >
                                <FormControlLabel
                                    control={<Checkbox size="small" color="black"
                                        checked={updateTreatment?.nextAntenatalTests?.some(test => test.testId === item.testId) ? true : false}
                                        onChange={() => {
                                            const isChecked = updateTreatment?.nextAntenatalTests?.some(test => test.testId === item.testId);
                                            if (!updateTreatment.nextAntenatalTests) {
                                                updateTreatment.nextAntenatalTests = []
                                            }
                                            const updatedNextAntenatalTests = isChecked
                                                ? updateTreatment.nextAntenatalTests.filter(test => test.testId !== item.testId) // Remove
                                                : [...updateTreatment.nextAntenatalTests, { testId: item.testId, "isAdditional": true }]; // Add
                                            setUpdateTreatment(prev => ({
                                                ...prev,
                                                nextAntenatalTests: updatedNextAntenatalTests
                                            }));
                                        }}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                border: 'none',
                                            },
                                        }}
                                    />}
                                    label={renderTestLabel(item)}
                                    sx={{
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '14px',
                                        },
                                    }}
                                />
                            </Grid>
                        ))}
                    {!edit && getTreatmentDetails?.nextAntenatalTests?.map((item, index) => (
                        item.isAdditional && <Grid size={{ xs: 12, md: 3 }} key={index} textAlign={'left'} >
                            <FormControlLabel
                                control={<Checkbox
                                    size="small"
                                    color="black"
                                    checked={true}
                                    disabled={true}
                                />}
                                label={renderTestLabel(item)}
                            />
                        </Grid>
                    ))}

                    {/* <Button variant="outlined">Add More</Button> */}
                    {edit && (
                        <Grid size={{ xs: 12, md: 3 }}>
                            <AsyncCreatableSelect
                                cacheOptions
                                defaultOptions={false}
                                loadOptions={loadAdditionalTestOptions}
                                placeholder="Add Test"
                                menuPlacement="top"
                                value={selectedAdditionalTest}
                                onChange={(selectedOption) => {
                                    if (!selectedOption) return;

                                    const alreadyExists =
                                        updateTreatment?.nextAntenatalTests?.some(
                                            (test) =>
                                                test.testId === selectedOption.testId
                                        );

                                    if (!alreadyExists) {
                                        setUpdateTreatment((prev) => ({
                                            ...prev,
                                            nextAntenatalTests: [
                                                ...(prev.nextAntenatalTests || []),
                                                {
                                                    testId: selectedOption.testId,
                                                    testName: selectedOption.testName,
                                                    isAdditional: true
                                                }
                                            ]
                                        }));
                                    }

                                    setSelectedAdditionalTest(null);
                                }}

                                onCreateOption={async (inputValue) => {
                                    try {
                                        const payload = {
                                            patientId,
                                            consultationId,
                                            testName: inputValue,
                                            customValue: null,
                                            category: "Other",
                                        };

                                        const response = await API.post(
                                            "/v1/tests/custom",
                                            payload
                                        );

                                        if (!response.success) {
                                            return;
                                        }

                                        const createdTest = response.data;

                                        setUpdateTreatment((prev) => ({
                                            ...prev,
                                            nextAntenatalTests: [
                                                ...(prev.nextAntenatalTests || []),
                                                {
                                                    testId: createdTest.id,
                                                    testName: createdTest.testName,
                                                    isAdditional: true
                                                }
                                            ]
                                        }));

                                    } catch (error) {
                                        console.error("Error creating custom test:", error);
                                    }
                                }}
                                styles={{
                                    ...styles.asyncSelect,
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 10000
                                    })
                                }}
                                menuPortalTarget={document.body}
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>}

            {recommendationError && (
                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }} sx={{
                    borderRadius: '10px',
                    border: "1px solid #E6E8EC",
                    p: 2
                }}>
                    <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 'bold' }}>
                        Please schedule the next visit manually.
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 1 }}>
                        <Typography sx={{ textAlign: 'left', fontSize: '14px', fontWeight: 'bold' }}>
                            Please schedule the next visit manually.
                        </Typography>
                        {edit && (
                            <Button
                                size="small"
                                variant="outlined"
                                startIcon={<RefreshIcon sx={{ fontSize: '16px !important' }} />}
                                onClick={generateRecommendation}
                                disabled={generating}
                                sx={{
                                    textTransform: 'none',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    borderColor: '#5C5CFF',
                                    color: '#5C5CFF',
                                    '&:hover': {
                                        borderColor: '#4A4AE0',
                                        backgroundColor: 'rgba(92, 92, 255, 0.04)',
                                    },
                                }}
                            >
                                {generating ? 'Retriggering...' : 'Retry AI Recommendation'}
                            </Button>
                        )}
                    </Box>

                    {/* Start Date */}
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={12} md={4}>
                            <TextField
                                label="Start Date"
                                type="date"
                                fullWidth
                                size="small"
                                value={manualRecommendation.startDate}
                                onChange={(e) =>
                                    setManualRecommendation(prev => ({
                                        ...prev,
                                        startDate: e.target.value,
                                        endDate: ""
                                    }))
                                }
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />

                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                label="End Date"
                                type="date"
                                fullWidth
                                size="small"
                                value={manualRecommendation.endDate}
                                disabled={!manualRecommendation.startDate}
                                inputProps={{
                                    min: manualRecommendation.startDate
                                }}
                                onChange={(e) =>
                                    setManualRecommendation(prev => ({
                                        ...prev,
                                        endDate: e.target.value
                                    }))
                                }
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        </Grid>
                    </Grid>

                    {/* Selected Tests */}
                    <Typography sx={{ fontWeight: '500' }} textAlign={'left'}>
                        Recommend Tests:
                    </Typography>
                    {isPreconception ? (
                        renderTestsPreconception(selectedTests.map(id => recommendation?.tests?.find(x => x.tenantTestId === id)).filter(Boolean))
                    ) : (
                        <Grid container mt={1} gap={1}>
                            {selectedTests.map(id => {
                                const test = recommendation?.tests?.find(x => x.tenantTestId === id);
                                if (!test) return null;
                                return (
                                    <FormControlLabel
                                        key={id}
                                        control={
                                            <Checkbox
                                                size="small"
                                                color="black"
                                                checked={true}
                                                onChange={() => handleTestSelection(test.tenantTestId)}
                                            />
                                        }
                                        label={renderTestLabel(test)}
                                    />
                                );
                            })}
                            {renderRecommendTest()}
                        </Grid>
                    )}

                    <Box
                        display="flex"
                        justifyContent="flex-end"
                        mt={3}
                    >
                        <Button
                            disabled={!manualRecommendation.startDate || !manualRecommendation.endDate}
                            variant="contained"
                            onClick={confirmRecommendation}
                        >
                            Confirm
                        </Button>
                    </Box>
                </Grid>
            )}

            {generating ? (
                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }} sx={{
                    borderRadius: '10px',
                    border: "1px solid #E6E8EC",
                    p: 2
                }}>
                    <CircularProgress />
                    <Typography mt={2}>
                        {loadingMessages[messageIndex]}
                    </Typography>
                    <Box mt={4}>
                        {[1, 2].map((item) => (
                            <Skeleton
                                key={item}
                                variant="rounded"
                                height={72}
                                sx={{
                                    mb: 2,
                                    borderRadius: 2
                                }}
                            />
                        ))}
                    </Box>
                </Grid>
            ) : recommendation && (
                <Box sx={{ paddingBottom: 8, width: '100%' }}>
                    <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }} sx={{
                        borderRadius: '10px',
                        border: "1px solid #E6E8EC",
                        p: 2,

                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, flexWrap: 'wrap', gap: 1 }}>
                            <Box>
                                <Typography sx={{ textAlign: 'left', color: '#5C5CFF', fontSize: '14px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <AutoAwesomeIcon sx={{ fontSize: '18px' }} /> AI suggested
                                </Typography>
                                <Typography sx={{ textAlign: 'left', fontSize: '13px', color: '#666' }}>
                                    Review and adjust before confirming.
                                </Typography>
                            </Box>
                            {edit && (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<RefreshIcon sx={{ fontSize: '16px !important' }} />}
                                    onClick={generateRecommendation}
                                    disabled={generating}
                                    sx={{
                                        textTransform: 'none',
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        borderColor: '#5C5CFF',
                                        color: '#5C5CFF',
                                        '&:hover': {
                                            borderColor: '#4A4AE0',
                                            backgroundColor: 'rgba(92, 92, 255, 0.04)',
                                        },
                                    }}
                                >
                                    {generating ? 'Regenerating...' : 'Retrigger Recommendation'}
                                </Button>
                            )}
                        </Box>
                        {(recommendation.nextVisit && recommendation?.nextVisit?.fromDate) ? (
                            <Grid container sx={{ border: '1px solid green', p: 1, borderRadius: '10px', backgroundColor: '#E9FCE9', mt: 1, mb: 1 }}>
                                <Grid xl={12} size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Typography sx={{ color: 'green', fontWeight: '500',fontSize: '14px', }} textAlign={'left'}>
                                        Recommend next appointment
                                    </Typography>
                                </Grid>
                                <Grid container spacing={2} mt={1} pl={1} pr={1} pb={1}>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="Start Date"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={manualRecommendation.startDate}
                                            disabled={!edit}
                                            inputProps={{
                                                min: moment().format('YYYY-MM-DD')
                                            }}
                                            onChange={(e) =>
                                                setManualRecommendation(prev => ({
                                                    ...prev,
                                                    startDate: e.target.value,
                                                    endDate: ""
                                                }))
                                            }
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="End Date"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={manualRecommendation.endDate}
                                            disabled={!edit || !manualRecommendation.startDate}
                                            inputProps={{
                                                min: manualRecommendation.startDate
                                            }}
                                            onChange={(e) =>
                                                setManualRecommendation(prev => ({
                                                    ...prev,
                                                    endDate: e.target.value
                                                }))
                                            }
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid xl={12} size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Typography textAlign={'left'}sx={{fontSize: '14px',}}>
                                        {recommendation?.nextVisit?.reason}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ) : (
                            <>
                                <Typography sx={{ fontWeight: '500',fontSize: '14px', }} textAlign={'left'}>
                                    Recommend next appointment:
                                </Typography>
                                <Grid container spacing={2} mt={2}>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="Start Date"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={manualRecommendation.startDate}
                                            disabled={!edit}
                                            inputProps={{
                                                min: moment().format('YYYY-MM-DD')
                                            }}
                                            onChange={(e) =>
                                                setManualRecommendation(prev => ({
                                                    ...prev,
                                                    startDate: e.target.value,
                                                    endDate: ""
                                                }))
                                            }
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="End Date"
                                            type="date"
                                            fullWidth
                                            size="small"
                                            value={manualRecommendation.endDate}
                                            disabled={!edit || !manualRecommendation.startDate}
                                            inputProps={{
                                                min: manualRecommendation.startDate
                                            }}
                                            onChange={(e) =>
                                                setManualRecommendation(prev => ({
                                                    ...prev,
                                                    endDate: e.target.value
                                                }))
                                            }
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        )}

                        {isPreconception ? (
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1, mb: 0.5 }}>
                                    <Typography sx={{ fontWeight: '500', fontSize: '14px' }} textAlign={'left'}>
                                        Recommend Tests:
                                    </Typography>
                                    {edit && (
                                        <Button
                                            size="small"
                                            startIcon={<RefreshIcon sx={{ fontSize: '15px !important' }} />}
                                            onClick={generateRecommendation}
                                            disabled={generating}
                                            sx={{
                                                textTransform: 'none',
                                                fontSize: '12px',
                                                color: '#5C5CFF',
                                                p: '2px 8px',
                                                minWidth: 'auto',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(92, 92, 255, 0.08)',
                                                },
                                            }}
                                        >
                                            {generating ? 'Retriggering...' : 'Retrigger Tests'}
                                        </Button>
                                    )}
                                </Box>
                                {renderTestsPreconception(recommendation.tests || [])}
                            </>
                        ) : (
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1, mb: 0.5 }}>
                                    <Typography sx={{ fontWeight: '500', fontSize: '14px' }} textAlign={'left'}>
                                        Recommend Tests:
                                    </Typography>
                                    {edit && (
                                        <Button
                                            size="small"
                                            startIcon={<RefreshIcon sx={{ fontSize: '15px !important' }} />}
                                            onClick={generateRecommendation}
                                            disabled={generating}
                                            sx={{
                                                textTransform: 'none',
                                                fontSize: '12px',
                                                color: '#5C5CFF',
                                                p: '2px 8px',
                                                minWidth: 'auto',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(92, 92, 255, 0.08)',
                                                },
                                            }}
                                        >
                                            {generating ? 'Retriggering...' : 'Retrigger Tests'}
                                        </Button>
                                    )}
                                </Box>
                                <Grid container spacing={1}>
                                    {recommendation.tests?.map(test => (
                                        <Grid item xs={12} md={6} key={test.tenantTestId}>
                                            <FormControlLabel
                                                sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        color="black"
                                                        disabled={!edit}
                                                        checked={selectedTests.includes(test.tenantTestId)}
                                                        onChange={() => handleTestSelection(test.tenantTestId)}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: '15px' } }} 
                                                    />
                                                }
                                                label={renderTestLabel(test)}
                                            />
                                        </Grid>
                                    ))}
                                    {edit && (
                                        <Grid size={{ xs: 12, md: 3 }}>
                                            {renderRecommendTest()}
                                        </Grid>
                                    )}
                                </Grid>
                            </>
                        )}

                        {/* Mother-Side Pathway / Consumer App Habit Loops */}
                        <Box sx={{ mt: 3, pt: 2, borderTop: '1px dashed #E0E0E0' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5, flexWrap: 'wrap', gap: 1 }}>
                                <Box>
                                    <Typography sx={{ fontWeight: '600', fontSize: '14px', color: '#1A1A1A', textAlign: 'left' }}>
                                        Mother-Side Pathway & Habit Loops
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', color: '#666', textAlign: 'left' }}>
                                        Select daily clinical monitoring protocols and reminder schedules to activate on the mother's Oni-Care app.
                                    </Typography>
                                </Box>
                                <Chip
                                    size="small"
                                    label={`${selectedConsumerModules.length} Active`}
                                    sx={{
                                        backgroundColor: selectedConsumerModules.length > 0 ? '#E8F5E9' : '#F5F5F5',
                                        color: selectedConsumerModules.length > 0 ? '#2E7D32' : '#757575',
                                        fontWeight: 600,
                                        fontSize: '12px',
                                    }}
                                />
                            </Box>

                            <Grid container spacing={1.5}>
                                {availableConsumerProtocols.map((protocol) => {
                                    const isChecked = selectedConsumerModules.includes(protocol.module);
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={protocol.module}>
                                            <Paper
                                                variant="outlined"
                                                onClick={() => edit && handleConsumerModuleToggle(protocol.module)}
                                                sx={{
                                                    p: 1.5,
                                                    borderRadius: '8px',
                                                    cursor: edit ? 'pointer' : 'default',
                                                    borderColor: isChecked ? '#F27704' : '#E6E8EC',
                                                    backgroundColor: isChecked ? '#FFF9F5' : '#FFFFFF',
                                                    transition: 'all 0.2s ease',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'space-between',
                                                    height: '100%',
                                                    boxSizing: 'border-box',
                                                    '&:hover': edit ? {
                                                        borderColor: '#F27704',
                                                        boxShadow: '0 2px 8px rgba(242, 119, 4, 0.08)',
                                                    } : {},
                                                }}
                                            >
                                                <Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                                            <Checkbox
                                                                size="small"
                                                                disabled={!edit}
                                                                checked={isChecked}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleConsumerModuleToggle(protocol.module);
                                                                }}
                                                                sx={{
                                                                    p: 0,
                                                                    color: '#D0D5DD',
                                                                    '&.Mui-checked': { color: '#F27704' },
                                                                }}
                                                            />
                                                            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#101828', textAlign: 'left' }}>
                                                                {protocol.label}
                                                            </Typography>
                                                        </Box>
                                                        {protocol.isRecommended && (
                                                            <Chip
                                                                size="small"
                                                                label="Recommended"
                                                                sx={{
                                                                    height: '20px',
                                                                    fontSize: '10px',
                                                                    fontWeight: 600,
                                                                    backgroundColor: '#ECFDF3',
                                                                    color: '#027A48',
                                                                }}
                                                            />
                                                        )}
                                                    </Box>

                                                    <Typography sx={{ fontSize: '11px', color: '#F27704', fontWeight: 500, mt: 0.75, textAlign: 'left' }}>
                                                        ⏰ {protocol.frequency}
                                                    </Typography>

                                                    <Typography sx={{ fontSize: '11px', color: '#667085', mt: 0.5, textAlign: 'left', lineHeight: 1.3 }}>
                                                        {protocol.description}
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Box>

                        {edit && <Box
                            display="flex"
                            justifyContent="flex-end"
                            mt={3}
                        >
                            <Button
                                variant="contained"
                                onClick={confirmRecommendation}
                                disabled={
                                    recommendation.isConfirmed &&
                                    !hasRecommendationChanges()
                                }
                            >  {recommendation.isConfirmed && !hasRecommendationChanges()
                                ? "Confirmed"
                                : "Confirm Recommendation"}
                            </Button>
                        </Box>}
                    </Grid>
                </Box>
            )}
        </Grid>
    }

    return (
        <Box sx={{
            flexGrow: 1,
            width: '100%',
            overflowX: 'hidden',
            height: {
                xs: 'auto',
                md: '78vh',
            },
        }} alignContent={'center'}>
            {!loader ? isMobile ? renderContent() : <Scrollbar padding="0 1rem 1rem 0rem"> {renderContent()}</Scrollbar>
                :
                <CircularProgress />
            }
        </Box>
    );
};

export default Treatment;